import { useLazyQuery, useQuery } from "@apollo/client/react"; 
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GET_PANTALLAS_RI } from '../../../data/graphQL/queries/ResumenIngreso/getPantallasRI';
import { GET_DATOS_GENERALES_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getDatosGeneralesRIResumen';
import { GET_CONDICIONES_GENERALES_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getCondicionesGeneralesRIResumen';
import { GET_ALIMENTACION_ENTERAL } from '../../../data/graphQL/queries/ResumenIngreso/getAlimentacionEnteralRIByDGId';
import { GET_ALIMENTACION_PARENTERAL } from '../../../data/graphQL/queries/ResumenIngreso/getAlimentacionParenteralRIByDGId';
import { GET_NPID } from '../../../data/graphQL/queries/ResumenIngreso/getNutricionParenteralRI';
import { GET_DISFAGIA_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getDisfagiaRIResumen';
import { GET_CUIDADOS_PALIATIVOS_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getCPResumen';
import { GET_CUIDADOS_DOMICILIARIOS_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getCDResumen';
import { GET_KETO_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getKetoResumen';
import { GET_PROFESIONALES_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getProfesionalesResumen';
import { GET_ADICIONALES_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getAdicionalesResumen';
import { GET_PROFESIONAL_CIERRE } from '../../../data/graphQL/queries/ResumenIngresoResumen/getProfesionalCierreRI';
import { GET_PRINT_RESUMEN } from '../../../data/graphQL/queries/ResumenIngresoResumen/getPrintResumen';
import { adaptPantallasRIArray } from '../../../adapters/resumenIngreso/pantallasRIAdapter';
import { adaptCondicionesGeneralesRIResumen } from '../../../adapters/resumenIngresoDetalle/condicionesGeneralesRIResumenAdapter';
import { adaptAEResumen } from '../../../adapters/resumenIngresoDetalle/AEResumenAdapter';
import { adaptAPResumen } from '../../../adapters/resumenIngresoDetalle/APResumenAdapter';
import { adaptNPIDResumen } from '../../../adapters/resumenIngresoDetalle/NPIDResumenAdapter';
import { adaptDIResumen } from '../../../adapters/resumenIngresoDetalle/DIAdapterResumen';
import { adaptCPResumen } from '../../../adapters/resumenIngresoDetalle/CPResumenAdapter';
import { adaptCDResumen } from '../../../adapters/resumenIngresoDetalle/CDResumenAdapter';
import { adaptKETOResumen } from '../../../adapters/resumenIngresoDetalle/KETOResumenAdapter';
import { adaptProfesionalResumen } from '../../../adapters/resumenIngresoDetalle/ProfsResumenAdapter';
import { adaptAdicionalesResumen } from '../../../adapters/resumenIngresoDetalle/adicionalesResumenAdapter';
import { adaptDatosGeneralesRIResumen } from '../../../adapters/resumenIngresoDetalle/datosGeneralesRIResumenAdapter';
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { Box, CircularProgress } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import './resumenIngresoDetalleContent.scss';
import './resumenIngresoDetalleContentPrint.scss';
import { GET_INDICACIONES_BY_PANTALLA } from '../../../data/graphQL/queries/ResumenIngreso/getIndicacionesRIByPantalla';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { adaptIndicacionesArray } from '../../../adapters/resumenIngreso/indicacionesAdapter';
import { adaptIndicacionesDetalladasArray } from '../../../adapters/resumenIngreso/indicacionesDetalladasAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import fileDownload from 'js-file-download';
import moment from 'moment';
import DocumentViewerBase64 from '../../../components/DocumentViewerBase64';
import { useApolloClient } from '@apollo/client/react';

const genericColumns = generateColumnsDefaultConfiguration([
  {
    headerName: 'Producto',
    field: 'nombreInsumo',
    flex: 6
  },
  {
    headerName: 'Cant. Diaria',
    field: 'cantidadDiaria',
    flex: 3

  },
  {
    headerName: 'Unidad',
    field: 'unidad',
    flex: 3
  }]
);
const columnsIndicacionesCP = generateColumnsDefaultConfiguration([
  {
    headerName: 'Medicamento',
    field: 'nombreInsumo',
    flex: 0.57
  },
  {
    headerName: 'Presentación',
    field: 'presentacion',
    flex: 0.25

  },
  {
    headerName: 'Dosis',
    field: 'cantidadDiaria',
    flex: 0.2
  }]
);


const Title = ({ children }) =>
  <div className='resumen-title-modulo'>
    <h3 className='resumen-title-modulo-text'>{children}</h3>
  </div>;


const ListChips = ({ value }) =>
  <Stack direction='row' spacing={1.25} useFlexGap flexWrap='wrap'>
    {value.map((chipValue, index) =>
      <div key={`chip-${chipValue}-index-${index}`} className='chip-resumen-ingreso-container'>
        {chipValue}
      </div>
    )}
  </Stack>;


const AttachedFile = ({ file, onClick }) =>
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px 8px 0px',
      borderRadius: 4,
      background: '#E0E1E3',
      alignSelf: 'flex-start',
      cursor: 'pointer'
    }}
    onClick={() => onClick(file)}>

    <AttachFileIcon sx={{ width: 21, height: 21, color: '#636A73' }} />
    <Typography variant='body2' sx={{ marginLeft: 1 }}>{file.titulo}</Typography>
  </Box>;


const inicioDeServicioDisplayNameAux = '¿El paciente requiere Soporte Nutricional?';

export const ResumenIngresoDetalleContent = ({ setChildrenAction }) => {
  const client = useApolloClient();

  const { state = {} } = useLocation();
  const { idDatosGeneralesRI } = state;

  const [resumenIngreso, setResumenIngreso] = useState({});
  const [modulosOptions, setModulosOptions] = useState([]);
  const [pantallas, setPantallas] = useState([]);

  const [exportLoading, setExportLoading] = useState(false);

  const [progSeleccAbrev, setProgSeleccAbrev] = useState([]);
  const [print, setPrint] = useState(false);
  const [profesionalCierre, setProfesionalCierre] = useState('');
  const [profesionalRealizoRI, setProfesionalRealizoRI] = useState('');
  const [firmaProfesional, setFirmaProfesional] = useState('');
  const [firmaValidador, setFirmaValidador] = useState('');
  const [soloCP, setSoloCP] = useState(false);

  const [filePreview, setFilePreview] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const { loading: getPantallasLoading, data: pantallasData } = useQuery(GET_PANTALLAS_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!pantallasData) return;

    const pantallasRI = adaptPantallasRIArray(pantallasData);
    setPantallas(pantallasRI);
    const modulesSet = new Set();
    pantallasRI.forEach((pantalla) => {
      pantalla.modulos.forEach((modulo) => {
        modulesSet.add(JSON.stringify(modulo));
      });
    });
    const uniqueModules = Array.from(modulesSet).
      map((modulo) => JSON.parse(modulo)).
      sort((a, b) => a.id - b.id);

    setModulosOptions(uniqueModules);
  }, [pantallasData]);

  const { loading: datosGeneralesLoading, data: datosGeneralesRIData } = useQuery(GET_DATOS_GENERALES_RESUMEN, {
    fetchPolicy: 'no-cache',
    variables: { idDatosGenerales: idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!datosGeneralesRIData) return;

    const datosGenerales = adaptDatosGeneralesRIResumen(datosGeneralesRIData?.datosGeneralesResumenRIByID);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...datosGenerales }));
  }, [datosGeneralesRIData]);

  const { loading: getCondGralesLoading, data: condGralRIData } = useQuery(GET_CONDICIONES_GENERALES_RESUMEN, {
    fetchPolicy: 'no-cache',
    variables: { idDatosGenerales: idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!condGralRIData) return;

    const condicionesGenerales = adaptCondicionesGeneralesRIResumen(condGralRIData?.condicionGeneralRIByID);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...condicionesGenerales }));
  }, [condGralRIData]);

  const [getIndicaciones] = useLazyQuery(GET_INDICACIONES_BY_PANTALLA, {
    fetchPolicy: 'no-cache'
  });

  const [getAlimentacionEnteral, { loading: getAlimentacionEnteralLoading, data: aeData }] = useLazyQuery(GET_ALIMENTACION_ENTERAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!aeData) return;

    const alimentacionEnteral = adaptAEResumen(aeData?.alimentacionEnteralRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...alimentacionEnteral }));
  }, [aeData]);

  const [getAlimentacionParenteral, { loading: getAlimentacionParenteralLoading, data: apData }] = useLazyQuery(GET_ALIMENTACION_PARENTERAL, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!apData) return;

    const alimentacionParenteral = adaptAPResumen(apData?.alimentacionParenteralRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...alimentacionParenteral }));
  }, [apData]);

  const [getNpid, { loading: getNpidLoading, data: npidData }] = useLazyQuery(GET_NPID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!npidData) return;
    const NPID = adaptNPIDResumen(npidData?.nutricionParenteralRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...NPID }));
  }, [npidData]);

  const [getDisfagia, { loading: getDisfagiaLoading, data: disfagiaData }] = useLazyQuery(GET_DISFAGIA_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!disfagiaData) return;
    const disfagia = adaptDIResumen(disfagiaData?.disfagiaRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...disfagia }));
  }, [disfagiaData]);

  const [getKeto, { loading: getKetoLoading, data: ketoData }] = useLazyQuery(GET_KETO_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!ketoData) return;
    const keto = adaptKETOResumen(ketoData?.ketosterilRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...keto }));
  }, [ketoData]);

  const [getAdicionales, { loading: getAdicionalesLoading, data: adicionalesData }] = useLazyQuery(GET_ADICIONALES_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!adicionalesData) return;

    const adicionales = adaptAdicionalesResumen(adicionalesData?.adicionalRIById);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...adicionales }));
  }, [adicionalesData]);

  const [getProfesionales, { loading: getProfesionalesLoading, data: profesionalesData }] = useLazyQuery(GET_PROFESIONALES_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!profesionalesData) return;

    const recoProfesionales = adaptProfesionalResumen(profesionalesData);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...recoProfesionales }));
  }, [profesionalesData]);

  const [getProfesionalCierre, { data: profesionalCierreData }] = useLazyQuery(GET_PROFESIONAL_CIERRE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!profesionalCierreData) return;

    const data = profesionalCierreData;
    const profesionalCierreNuevo = data.profesionalCierreRI.apellidoModificacion != "" ? {
      apellido: data.profesionalCierreRI.apellidoModificacion,
      nombre: data.profesionalCierreRI.nombreModificacion,
      matriculaNac: data.profesionalCierreRI.matriculaNacModificacion,
      matriculaProv: data.profesionalCierreRI.matriculaProvModificacion,
      fechaCierreRI: data.profesionalCierreRI.fechaCierreRI,
      firmaMedicoStr: data.profesionalCierreRI.firmaMedicoModificacionStr,
      idEstadoValidacion: data.profesionalCierreRI.idEstadoValidacion
    } : {
      apellido: data.profesionalCierreRI.apellido,
      nombre: data.profesionalCierreRI.nombre,
      matriculaNac: data.profesionalCierreRI.matriculaNac,
      matriculaProv: data.profesionalCierreRI.matriculaProv,
      fechaCierreRI: data.profesionalCierreRI.fechaCierreRI,
      firmaMedicoStr: data.profesionalCierreRI.firmaMedicoStr,
      idEstadoValidacion: data.profesionalCierreRI.idEstadoValidacion
    };
    setFirmaProfesional(`data:image/jpg;base64,${profesionalCierreNuevo.firmaMedicoStr}`);
    setFirmaValidador(data.profesionalCierreRI.firmaValidadorStr != "" ? `data:image/jpg;base64,${data.profesionalCierreRI.firmaValidadorStr}` : "");
    setProfesionalCierre(profesionalCierreNuevo);
    setProfesionalRealizoRI(data.profesionalCierreRI.apellidoModificacion != "" ? {
      apellido: data.profesionalCierreRI.apellido,
      nombre: data.profesionalCierreRI.nombre,
      matriculaNac: data.profesionalCierreRI.matriculaNac,
      matriculaProv: data.profesionalCierreRI.matriculaProv,
      fechaCierreRI: data.profesionalCierreRI.fechaCierreRI
    } : null);
  }, [profesionalCierreData]);

  useEffect(() => {
    if (profesionalCierre !== "")
      printReport();
  }, [profesionalCierre]);

  const [getCuidadosDomiciliarios, { loading: getCuidadosDomiciliariosLoading, data: cdData }] = useLazyQuery(GET_CUIDADOS_DOMICILIARIOS_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!cdData) return;

    const cuidadosDomiciliarios = adaptCDResumen(cdData?.cuidadosDomiciliariosRIById);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...cuidadosDomiciliarios }));
  }, [cdData]);


  const [getCuidadosPaliativos, { loading: getCuidadosPaliativosLoading, data: cpData }] = useLazyQuery(GET_CUIDADOS_PALIATIVOS_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!cpData) return;

    const cuidadosPaliativos = adaptCPResumen(cpData?.cuidadosPaliativosRIByDatosGeneralesId);
    setResumenIngreso((currentRI) => ({ ...currentRI, ...cuidadosPaliativos }));
  }, [cpData])

  const pageLoading = useMemo(() =>
    getPantallasLoading ||
    datosGeneralesLoading ||
    getCondGralesLoading ||
    getAlimentacionEnteralLoading ||
    getAlimentacionParenteralLoading ||
    getNpidLoading ||
    getDisfagiaLoading ||
    getKetoLoading ||
    getAdicionalesLoading ||
    getProfesionalesLoading ||
    getCuidadosDomiciliariosLoading ||
    getCuidadosPaliativosLoading,
    [
      getPantallasLoading,
      datosGeneralesLoading,
      getCondGralesLoading,
      getAlimentacionEnteralLoading,
      getAlimentacionParenteralLoading,
      getNpidLoading,
      getDisfagiaLoading,
      getKetoLoading,
      getAdicionalesLoading,
      getProfesionalesLoading,
      getCuidadosDomiciliariosLoading,
      getCuidadosPaliativosLoading]
  );

  useEffect(() => {
    if (!resumenIngreso?.selectedPrograms?.length || !modulosOptions?.length) return;

    let isMounted = true; // 👈 flag local al efecto

    const programasSeleccionadosAbrev = resumenIngreso?.selectedProgramNames?.map(
      (mo) => mo.displayName
    );

    setProgSeleccAbrev(programasSeleccionadosAbrev);
    setSoloCP(
      programasSeleccionadosAbrev.includes('CP') &&
      programasSeleccionadosAbrev.length === 1
    );

    // helper para no repetir tanto código en cada getIndicaciones
    const safeGetIndicaciones = async (
      pantallaMatchStr,
      setKey,
      adaptFn
    ) => {
      const pantalla = pantallas.find(
        (p) => p.displayName === pantallaMatchStr
      );

      if (!pantalla?.id) {
        console.warn(`No se encontró la pantalla ${pantallaMatchStr}`);
        return;
      }

      try {
        const { data } = await client.query({
          query: GET_INDICACIONES_BY_PANTALLA,
          variables: {
            idPantallaRI: pantalla.id,
            idDatosGeneralesRI
          },
          fetchPolicy: 'no-cache'
        });

        if (!isMounted || !data) return;

        setResumenIngreso((currentRI) => ({
          ...currentRI,
          [setKey]: adaptFn(data)
        }));
      } catch (error) {
        console.error(`Error obteniendo indicaciones de ${pantallaMatchStr}`, error);
      }
    };

    if (
      programasSeleccionadosAbrev.includes('AE') ||
      programasSeleccionadosAbrev.includes('CEAE') ||
      programasSeleccionadosAbrev.includes('SSAE')
    ) {
      getAlimentacionEnteral({ variables: { idDatosGenerales: idDatosGeneralesRI } });

      safeGetIndicaciones('AE', 'indicacionesAE', adaptIndicacionesArray);
    }

    if (
      programasSeleccionadosAbrev.includes('AO') ||
      programasSeleccionadosAbrev.includes('AOC') ||
      programasSeleccionadosAbrev.includes('CEAO')
    ) {
      safeGetIndicaciones('AO', 'indicacionesAO', adaptIndicacionesArray);
    }

    if (programasSeleccionadosAbrev.includes('AP')) {
      getAlimentacionParenteral({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    if (
      programasSeleccionadosAbrev.includes('NPID') ||
      programasSeleccionadosAbrev.includes('SIP')
    ) {
      getNpid({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    if (programasSeleccionadosAbrev.includes('DI')) {
      getDisfagia({ variables: { idDatosGenerales: idDatosGeneralesRI } });

      safeGetIndicaciones('DI', 'indicacionesDI', adaptIndicacionesArray);
    }

    if (programasSeleccionadosAbrev.includes('KETO')) {
      getKeto({ variables: { idDatosGenerales: idDatosGeneralesRI } });

      safeGetIndicaciones('Keto', 'indicacionesKeto', adaptIndicacionesArray);
    }

    if (programasSeleccionadosAbrev.includes('CD')) {
      getCuidadosDomiciliarios({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    if (programasSeleccionadosAbrev.includes('CP')) {
      safeGetIndicaciones('CP', 'indicacionesCP', adaptIndicacionesDetalladasArray);
    }

    if (
      programasSeleccionadosAbrev.includes('CP') ||
      programasSeleccionadosAbrev.includes('CD')
    ) {
      getCuidadosPaliativos({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    if (
      programasSeleccionadosAbrev.includes('CP') ||
      programasSeleccionadosAbrev.includes('CD')
    ) {
      getAdicionales({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    if (
      programasSeleccionadosAbrev.includes('AOC') ||
      programasSeleccionadosAbrev.includes('CEAO') ||
      programasSeleccionadosAbrev.includes('CEAE') ||
      programasSeleccionadosAbrev.includes('CP') ||
      programasSeleccionadosAbrev.includes('CD')
    ) {
      getProfesionales({ variables: { idDatosGenerales: idDatosGeneralesRI } });
    }

    // 👇 cleanup del efecto
    return () => {
      isMounted = false;
    };
  }, [resumenIngreso?.selectedPrograms, modulosOptions, idDatosGeneralesRI, client]);


  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        <CustomButton
          size='small'
          disabled={pageLoading}
          isLoading={exportLoading}
          onClick={handleExport}>

          Exportar
        </CustomButton>
      </div>
    );
  }, [
    setChildrenAction,
    pageLoading,
    exportLoading,
    resumenIngreso]
  );

  useEffect(() => {
    if (print) {
      getProfesionalCierre({ variables: { idDatosGeneralesRI: idDatosGeneralesRI } });
    }
  }, [print, idDatosGeneralesRI]);

  const handleExport = async () => {
    setExportLoading(true);
    setPrint(true);
  };

  const [getPrintResumen, { loading: loadingPrintResumen, data: printData }] = useLazyQuery(GET_PRINT_RESUMEN, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!printData) return;

    if (printData.printResumenIngreso != null) {
      const arr = new Uint8Array(printData.printResumenIngreso);
      const documento = new Blob([arr], { type: 'application/pdf' });
      const fileName = `Resumen-Ingreso-${idDatosGeneralesRI}.pdf`;
      fileDownload(documento, fileName);
    } else {
      toast.error('No se pudo exportar el Resumen, intentelo nuevamente más tarde.');
    }
  }, [printData])


  const printReport = async () => {
    try {
      const resumenIngresoHTML = document.getElementById('resumenResumenIngresoPrint');
      getPrintResumen({
        variables: {
          resumen: resumenIngresoHTML.innerHTML.toString(),
          numeroRI: idDatosGeneralesRI.toString(),
          soloCP: progSeleccAbrev.includes('CP') && progSeleccAbrev.length === 1
        }
      });
    } catch (error) {
      console.log(error);
      toast.error('No se pudo exportar el Resumen, intentelo nuevamente más tarde.');
    } finally {
      setExportLoading(false);
      setPrint(false);
    }
  };

  const onClickFile = (file) => {
    setFilePreview(file);
    setOpenPreview(true);
  };

  const shouldHideFieldForOnlyCP = (fieldName) => {
    return programOnlyCP && (
      fieldName === 'diagnosticoAlta' ||
      fieldName === 'idComboRIValorNivelActividad' ||
      fieldName === 'buenaTolerancia' ||
      fieldName === 'continuarOtroTratamiento' ||
      fieldName === 'descOtroTratamiento' ||
      fieldName === 'idComboRIValorFasePaciente' ||
      fieldName === 'comprendeAceptaServicio' ||
      fieldName === 'higiene');


  };

  const renderValue = (field, fieldKey) => {
    const { name } = field;
    const value = resumenIngreso[name];

    if (value === null || value === undefined || shouldHideFieldForOnlyCP(name)) return;

    let element;

    if (name === 'inicioDeServicio' && programOnlyCP) {
      field.displayName = inicioDeServicioDisplayNameAux;
    }

    switch (name) {
      case 'selectedPrograms':
        element = <ListChips value={value.map((id) => resumenIngreso.selectedProgramNames.find((x) => x.id === id)?.displayName)} />;
        break;
      case 'diagnosticosRI':
      case 'alergias':
      case 'diasConexionSemanaMagistralAP':
      case 'diasConexionSemanaAP':
      case 'diasConexionSemanaNPID':
      case 'diasConexionSemanaMagistralNPID':
      case 'dIDisfagiaARI':
      case 'dIAlimentacionActualRI':
      case 'dIHidratacionActualRI':
      case 'profesionalRI':
      case 'profesionalEspecialidadRI':
      case 'requerimientosAdicionales':
      case 'antecedentesClinicos':
      case 'justificacionSoporteRI':
      case 'requerimientosExtraNutricionalesRI':
        if (name === 'requerimientosAdicionales' && value.length === 0) {
          element = 'No';
          break;
        }
        element = <ListChips value={value} />;
        break;
      case 'consentimientoInput':
        element = <AttachedFile file={{ ...value, titulo: 'Consentimiento informado' }} onClick={onClickFile} />;
        break;
      case 'laboratorioAdjunto':
      case 'laboratorioAdjuntoNPID':
      case 'videodeglucionAdjunto':
      case 'videodeglucionAdjuntoCD':
      case 'videodeglucionAdjuntoCP':
      case 'directivasAdjunto':
      case 'laboratorioAdjuntoKETO':
        element = <AttachedFile file={value} onClick={onClickFile} />;
        break;
      // case 'firmaInput':
      //     element = <FirmaImage file={value} />;
      //     break;
      case 'indicacionesAE':
      case 'indicacionesAO':
      case 'indicacionesDI':
      case 'indicacionesKeto':
        element = <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={genericColumns}
            rows={value}
            toolbar={false}
            hideFooter />

        </Box>;
        break;
      case 'estudioAdjunto':
        element = <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={generateColumnsDefaultConfiguration([{
              headerName: "Nombre del estudio",
              renderCell: (cellProps) => {
                return <Box sx={{ my: 10 }}><AttachedFile file={cellProps.row} onClick={onClickFile} /></Box>;
              },
              flex: 3,
              field: "estudio"
            }, {}])}
            rows={value}
            toolbar={false}
            hideFooter />

        </Box>;
        break;
      case 'cPMedicacionDosificacionRI':
        element = <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={generateColumnsDefaultConfiguration([{ field: 'descripcion', headerName: 'Tratamiento', flex: 10 }, {}])}
            rows={value}
            toolbar={false}
            hideFooter />

        </Box>;
        break;
      case 'indicacionesCP':
        element = <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={columnsIndicacionesCP}
            rows={value}
            toolbar={false}
            hideFooter />

        </Box>;
        break;
      case 'centroReferencia':
      case 'enfermedadOncologica':
      case 'domicilioAccesible':
      case 'aguaPotable':
      case 'redElectrica':
      case 'comprendeAceptaServicio':
      case 'higiene':
      case 'almacenamiento':
      case 'cuidador':
      case 'internacionDomiciliaria':
      case 'dispositivoParaVideoConf':
      case 'continuarOtroTratamiento':
      case 'evaluacionFamiliaPsicosocial':
      case 'higieneInstitucion':
      case 'almacenamientoInstitucion':
      case 'personalInstitucion':
      case 'consentimientoInformado':
      case 'cambioSNGdomicilio':
      case 'accesoBuenEstado':
      case 'insercionCateterNormal':
      case 'magistral':
      case 'bAPestandar':
      case 'bAPxAdelantado':
      case 'presenciaEdemas':
      case 'cateterNormalNPID':
      case 'bAPestandarNPID':
      case 'magistralNPID':
      case 'videodeglucion':
      case 'videodeglucionCD':
      case 'videodeglucionCP':
      case 'episodiosNeumonia':
      case 'traqueostomia':
      case 'lucido':
      case 'compromisoMotor':
      case 'actividadMotoraAlAlimentarse':
      case 'directivasAnticipadas':
      case 'antecedenteAlcoholismo':
      case 'antecedenteConsumoSustanciaCD':
      case 'antecedenteConsumoSustancias':
      case 'sondaVesicalCP':
      case 'cateterCP':
      case 'sondaNasogastricaCP':
      case 'soporteNutricionalCP':
      case 'viveSolo':
      case 'cuidadoresContratados':
      case 'claudicacionFamiliar':
      case 'traqueostomiaCD':
      case 'sondaVesicalCD':
      case 'ostomiaCD':
      case 'cateterCD':
      case 'sondaNasogastricaCD':
      case 'requiereSoporteNutricionalCD':
      case 'antecedentesAlcoholismo':
      case 'infusionDrogas':
      case 'infusionesPrevias':
      case 'hemodialisisIncremental':
      case 'quiereDialisis':
      case 'txrenalConDeterioro':
      case 'recuperacionRenalDialisis':
      case 'nadaPorBoca':
        element = value ? 'SI' : 'NO';
        break;
      case 'conclusion':
        element = value ? 'APTO' : 'NO APTO';
        break;
      case 'aduESAS':
      case 'pedGMFS':
      case 'pedFLACCR':
      case 'pedGustaveRoussy':
      case 'pedFPSR':
      case 'escalaNumericaDolor':
        element = value ? 'Si' : 'No corresponde';
        break;
      case 'llevaBomba':
        element = value != null ? value ? 'SI' : 'NO' : '';
        break;
      default:
        element = value;
        break;
    }

    return (
      <Grid key={fieldKey} sx={{ display: 'flex', flexDirection: 'column' }} rowGap={1} size={{ xs: 12, md: field.col }}>
        {!!field.displayName && <strong>{field.displayName}</strong>}
        {element}
      </Grid>);

  };

  const filterByAge = (sections, esAdulto) => {
    return sections
      .map((section) => ({
        ...section,
        subSections: section.subSections
          .map((subSection) => ({
            ...subSection,
            elements: subSection.elements.filter((element) => {
              const elementName = element.name.toLowerCase();

              if (esAdulto) {
                return !elementName.includes('ped');
              }

              return (
                !elementName.includes('adu') &&
                !elementName.includes('karnofsky')
              );
            })
          }))
          .filter((subSection) => {
            const title = subSection.title.toLowerCase();

            if (subSection.elements.length === 0) {
              return false;
            }

            if (esAdulto) {
              return !title.includes('ped');
            }

            return !title.includes('adu');
          })
      }))
      .filter((section) => section.subSections.length > 0);
  };

  const filterCondicionesGenerales = (sections, comboRIValorLugarRI) => {
    return sections.map((section) => {
      section.subSections = section.subSections.filter((subSection) => {
        if (comboRIValorLugarRI === 'Domicilio') {
          return subSection.title !== 'Condiciones de la institución donde se presta el servicio';
        } else {
          return subSection.title !== 'Condiciones del domicilio según referencia paciente/cuidador';
        }
      });
      return section;
    }).filter((section) => section.subSections.length > 0);
  };


  const filteredModules = useMemo(() => {
    if (!resumenIngreso.selectedPrograms?.length || !modulosOptions?.length || !pantallas?.length) {
      return modulos.filter((mod) =>
        ['Datos Generales', 'Condiciones Generales'].includes(mod.displayName)
      );
    }

    const selectedProgramNames = modulosOptions.
      filter((mod) => resumenIngreso.selectedPrograms.includes(mod.id)).
      map((mod) => mod.displayName);

    const relevantScreens = pantallas.
      filter((pantalla) => pantalla.modulos.some((mod) => selectedProgramNames.includes(mod.displayName))).
      map((pantalla) => pantalla.displayName);

    if (relevantScreens.includes("Cuidados Domiciliario") || relevantScreens.includes("CP")) {
      relevantScreens.push("Adicional");
    }

    // si es solo CP 
    if (
      resumenIngreso.selectedPrograms.length == 1 &&
      resumenIngreso.selectedProgramNames[0].displayName == 'CP') {
      return modulosSoloCP.filter((mod) =>
        ['Datos Generales', 'Condiciones Generales'].includes(mod.displayName) ||
        relevantScreens.includes(mod.key)
      ).map((mod) => {
        mod.sections = filterByAge(mod.sections, resumenIngreso.edadAnios > 15);

        if (mod.displayName === 'Condiciones Generales') {
          mod.sections = filterCondicionesGenerales(mod.sections, resumenIngreso.comboRIValorLugarRI);
        }
        return mod;
      });
    } else {
      return modulos.filter((mod) =>
        ['Datos Generales', 'Condiciones Generales'].includes(mod.displayName) ||
        relevantScreens.includes(mod.key)
      ).map((mod) => {
        mod.sections = filterByAge(mod.sections, resumenIngreso.edadAnios > 15);

        if (mod.displayName === 'Condiciones Generales') {
          mod.sections = filterCondicionesGenerales(mod.sections, resumenIngreso.comboRIValorLugarRI);
        }
        return mod;
      });
    }
  }, [resumenIngreso.selectedPrograms, resumenIngreso.comboRIValorLugarRI, modulosOptions, pantallas]);

  const mostrarEspecialistas = useMemo(() => {
    return (
      progSeleccAbrev.includes('CEAO') ||
      progSeleccAbrev.includes('CEAE') ||
      progSeleccAbrev.includes('CD') ||
      progSeleccAbrev.includes('AOC'));

  }, [progSeleccAbrev]);

  const programOnlyCP = useMemo(() => {
    return progSeleccAbrev?.length === 1 && progSeleccAbrev[0] === 'CP';
  }, [progSeleccAbrev]);

  if (pageLoading) {
    return <Card elevation={1}>
      <CardContent sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '30vh'
      }}>
        <CircularProgress size={40} />
      </CardContent>
    </Card>;
  }

  const getTitleModulo = (modulo) => {
    if (modulo.key === 'NPID') {

      const SIP = modulosOptions?.find((x) => x.displayName === 'SIP');
      if (resumenIngreso.selectedPrograms.includes(SIP?.id))
        return 'Programa SIP';
      return modulo.displayName;
    } else if (modulo.key === 'AO') {
      const AOC = modulosOptions?.find((x) => x.displayName === 'AOC');
      if (resumenIngreso.selectedPrograms.includes(AOC?.id))
        return 'Programa AOC';
    } else if (modulo.key === 'AE') {
      const SSAE = modulosOptions?.find((x) => x.displayName === 'SSAE');
      if (resumenIngreso.selectedPrograms.includes(SSAE?.id))
        return 'Programa SSAE';
    }
    return modulo.displayName;
  };

  return (
    <>
      <div id='resumenResumenIngreso' style={{ width: '100%', height: '100%' }}>
        <Stack className='resumen-ingreso-resumen-container' direction='column' spacing={4} style={{ color: 'black !important', width: '100%', height: '100%' }}>
          {filteredModules.map((modulo, moduloIndex) =>
            <div key={`modulo-${moduloIndex}`}>
              <Title>{getTitleModulo(modulo)}</Title>
              {modulo.sections.map((section, sectionIndex) =>
                <Card
                  key={`section-${sectionIndex}-modulo-${moduloIndex}`}
                  elevation={1}
                  sx={{ marginTop: 2, borderRadius: '10px' }}>

                  <CardContent>
                    {section.subSections.map((subSection, subSectionIndex) => {
                      const needMargin = section.subSections.length > 1 && subSectionIndex !== 0;
                      return (
                        <Box
                          key={`subSection-${subSectionIndex}-section-${sectionIndex}-modulo-${moduloIndex}`}
                          sx={needMargin ? { mt: 2.5 } : {}}>

                          {subSection.title && <h3 className='subsection-title'>{subSection.title}</h3>}
                          <Grid container columnSpacing={2} rowGap={2}>
                            {subSection.elements.map((field, fieldIndex) =>
                              renderValue(
                                field,
                                `subSection-${subSectionIndex}-section-${sectionIndex}-modulo-${moduloIndex}-field-${fieldIndex}`
                              )
                            )}
                          </Grid>
                        </Box>);

                    })}
                  </CardContent>
                </Card>
              )}
            </div>
          )}
        </Stack>
      </div>

      {openPreview && <DocumentViewerBase64 data={filePreview} setOpenDlg={setOpenPreview} />}

      {print && resumenIngreso != null &&
        <div id='resumenResumenIngresoPrint' style={{ width: '100%', height: '100%', padding: '10px' }}>
          <div className='pr-seccion-titulo'>Datos Generales</div>

          {/* Programas */}
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Programa tipo</div>
          <div className='pr-tabla'>
            <table role="presentation" border="0" cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }} >
              <tr>
                <td>
                  {
                    progSeleccAbrev.length > 0 &&
                    progSeleccAbrev.map((req) => {
                      return ' - ' + req;
                    })
                  }
                </td>
              </tr>
            </table>
          </div>

          {/* Datos filiatorios */}
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Datos filiatorios</div>
          <div className='pr-tabla'>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='22%'><strong>N° HC:</strong> {resumenIngreso?.hC}</td>
                <td width='25%'><strong>Apellido:</strong> {resumenIngreso?.apellido}</td>
                <td width='30%'><strong>Nombre:</strong> {resumenIngreso?.nombre}</td>
                <td width='23%'><strong>DNI N°:</strong> {resumenIngreso?.dNI}</td>
              </tr>
            </table>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='22%' style={{ borderTop: '0' }}><strong>Fecha nacimiento:</strong> {resumenIngreso?.fechaNacimiento}</td>
                <td width='13%' style={{ borderTop: '0' }}><strong>Edad:</strong> {resumenIngreso?.edadAnios}</td>
                <td width='12%' style={{ borderTop: '0' }}><strong>Sexo:</strong> {resumenIngreso?.sexo}</td>
                <td style={{ borderTop: '0' }}><strong>Domicilio:</strong> {resumenIngreso?.domicilio}</td>
              </tr>
              <tr>
                <td colSpan={3}><strong>Financiador:</strong> {resumenIngreso?.financiador}</td>
                <td colSpan={1}><strong>N° afiliado:</strong> {resumenIngreso?.nroAfiliado}</td>
              </tr>
            </table>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='35%' style={{ borderTop: '0' }}><strong>Teléfono de contacto:</strong> {resumenIngreso?.telContacto}</td>
                <td width='35%' style={{ borderTop: '0' }}><strong>Familiar de contacto:</strong> {resumenIngreso?.familiarContacto}</td>
                <td width='30%' style={{ borderTop: '0' }}><strong>Teléfono familiar:</strong> {resumenIngreso?.telFamiliar}</td>
              </tr>
              <tr>
                <td colSpan={3}><strong>Médico de contacto:</strong> {resumenIngreso?.medicoPrescriptor}</td>
              </tr>
            </table>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='45%' style={{ borderTop: '0' }}><strong>Lugar donde se prestará el servicio:</strong> {resumenIngreso?.comboRIValorLugarServicio}</td>
                <td width='55%' style={{ borderTop: '0' }}><strong>Centro de referencia:</strong> {resumenIngreso?.centroReferencia ? 'SI' : 'NO'}</td>
              </tr>
            </table>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='20%' style={{ borderTop: '0' }}><strong>Lugar de RI:</strong> {resumenIngreso?.comboRIValorLugarRI}</td>
                <td width='50%' style={{ borderTop: '0' }}><strong>¿Qué servicio de emergencia posee?:</strong> {resumenIngreso?.servicioEmergencia}</td>
                <td width='30%' style={{ borderTop: '0' }}><strong>Teléfono de emergencia:</strong> {resumenIngreso?.telefonoEmergencia}</td>
              </tr>
            </table>
          </div>

          {/* Resumen de HCL */}
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Resumen de HCL</div>
          <div className='pr-tabla'>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr><td><strong>Resumen de HCL:</strong> {resumenIngreso?.resumenHCL}</td></tr>
              <tr style={{ display: !soloCP ? 'block' : 'none' }}><td><strong>Diagnóstico de alta:</strong> {resumenIngreso?.diagnosticoAlta}</td></tr>
              <tr>
                <td><strong>Diagnóstico CIE-10:</strong>
                  {
                    resumenIngreso?.diagnosticosRI != null && resumenIngreso?.diagnosticosRI.map((diag) => {
                      return ' - ' + diag;
                    })
                  }
                </td>
              </tr>
              <tr><td><strong>Enf. que motiva el soporte es oncologica:</strong> {resumenIngreso?.enfermedadOncologica ? 'SI' : 'NO'}</td></tr>
              <tr><td><strong>Antecedentes Clínicos relevantes:</strong>
                {
                  resumenIngreso?.antecedentesClinicos != null && resumenIngreso?.antecedentesClinicos.map((antec) => {
                    return ' - ' + antec;
                  })
                }</td>
              </tr>
              <tr><td><strong>Comentarios relevantes de antecedentes:</strong> {resumenIngreso?.comentarioRelevante}</td></tr>
              <tr><td><strong>Alergias relevantes:</strong>
                {
                  resumenIngreso?.alergias != null && resumenIngreso?.alergias.map((alergia) => {
                    if (alergia != 'Otros')
                      return ' - ' + alergia;
                    else {
                      return ' - Otros: ' + resumenIngreso?.otrasAlergias
                    }
                  })                  
                }
              </td>
              </tr>
              <tr><td><strong>Medicación habitual:</strong> {resumenIngreso?.medicacionHabitual}</td></tr>
            </table>
          </div>
          {/* Condición Clínica */}
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Condición Clínica</div>
          <div className='pr-tabla' style={{ width: '100%' }}>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td width='50%'><strong>Estable hemodinámicamente:</strong> {resumenIngreso?.estableHemodinamicamente}</td>
                <td width='50%'><strong>Estable de su enfermedad de base:</strong> {resumenIngreso?.estableEnfermedad}</td>
              </tr>
              <tr>
                <td width='50%'><strong>Nivel de conciencia normal:</strong> {resumenIngreso?.nivelConciencia}</td>
                <td width='50%'><strong>Escaras :</strong> {resumenIngreso?.escaras}</td>
              </tr>
              <tr>
                <td width='50%'><strong>Ostomías:</strong> {resumenIngreso?.ostomias}</td>
                <td width='50%'><strong>Otros relevantes:</strong> {resumenIngreso?.otrosRelevantes}</td>
              </tr>
            </table>
          </div>

          {/* Datos Clínicos */}
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Datos Clínicos</div>
          <div className='pr-tabla' style={{ width: '100%', display: resumenIngreso?.edadAnios > 15 ? 'block' : 'none' }}>
            <div>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                  <td width='20%'><strong>Peso actual(Kg):</strong> {resumenIngreso?.pesoActual}</td>
                  <td width='18%'><strong>Talla (m):</strong> {resumenIngreso?.talla}</td>
                  <td width='22%'><strong>Nivel de actividad:</strong> {resumenIngreso?.idComboRIValorNivelActividad}</td>
                  <td width='40%'><strong>Período de perdida de peso :</strong> {resumenIngreso?.idComboRIValorAduPerdidaPeso}</td>
                </tr>
                <tr style={{ display: soloCP ? 'block' : 'none' }}>
                  <td width='20%'><strong>Peso actual(Kg):</strong> {resumenIngreso?.pesoActual}</td>
                  <td width='18%'><strong>Talla (m):</strong> {resumenIngreso?.talla}</td>
                  <td width='62%' colSpan={2}><strong>Período de perdida de peso :</strong> {resumenIngreso?.idComboRIValorAduPerdidaPeso}</td>
                </tr>
                <tr>
                  <td width='20%'><strong>Peso habitual(Kg):</strong> {resumenIngreso?.aduPesoHabitual}</td>
                  <td width='18%'><strong>Evaluado:</strong> {resumenIngreso?.idComboRIValorAduEvaluado}</td>
                  <td width='22%'><strong>IMC:</strong> {resumenIngreso?.aduIMC}</td>
                  <td width='40%'><strong>% Pérdida de peso :</strong> {resumenIngreso?.aduPerdidaPeso}</td>
                </tr>
              </table>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr>
                  <td width='50%' style={{ borderTop: '0' }}><strong>Grado de desnutrición:</strong> {resumenIngreso?.idComboRIValorAduGradoDesnutricion}</td>
                  <td width='50%' style={{ borderTop: '0' }}><strong>Diagnóstico nutricional:</strong> {resumenIngreso?.idComboRIValorAduDiagnosticoNutricional}</td>
                </tr>
                <tr>
                  <td width='100%' colSpan={2}><strong>Meta del soporte nutricional:</strong> {resumenIngreso?.idComboRIValorAduMetaNutricional}</td>
                </tr>
                <tr>
                  <td width='100%' colSpan={2}><strong>Requerimientos extra nutricionales:</strong>
                    {
                      resumenIngreso?.requerimientosExtraNutricionalesRI != null && resumenIngreso?.requerimientosExtraNutricionalesRI.map((req) => {
                        return ' - ' + req;
                      })
                    }
                  </td>
                </tr>
                <tr style={{ display: progSeleccAbrev.some((p) => !['CP', 'CD', 'KETO'].includes(p)) ? 'block' : 'none' }}>
                  <td width='100%' colSpan={2}><strong>Justificación Soporte:</strong>
                    {
                      resumenIngreso?.justificacionSoporteRI != null && resumenIngreso?.justificacionSoporteRI.map((req) => {
                        return ' - ' + req;
                      })
                    }
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div className='pr-tabla' style={{ width: '100%', display: resumenIngreso?.edadAnios <= 15 ? 'block' : 'none' }}>
            <div>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                  <td width='20%'><strong>Peso actual(Kg):</strong> {resumenIngreso?.pesoActual}</td>
                  <td width='18%'><strong>Talla (m):</strong> {resumenIngreso?.talla}</td>
                  <td width='22%'><strong>Nivel de actividad:</strong> {resumenIngreso?.idComboRIValorNivelActividad}</td>
                  <td width='40%'><strong>Circunferencia media braquial (cm):</strong> {resumenIngreso?.pedCircunferenciaMBraquial}</td>
                </tr>
                <tr style={{ display: soloCP ? 'block' : 'none' }}>
                  <td width='20%'><strong>Peso actual(Kg):</strong> {resumenIngreso?.pesoActual}</td>
                  <td width='18%'><strong>Talla (m):</strong> {resumenIngreso?.talla}</td>
                  <td width='62%' colSpan={2}><strong>Circunferencia media braquial (cm):</strong> {resumenIngreso?.pedCircunferenciaMBraquial}</td>
                </tr>
                <tr>
                  <td width='20%'><strong>Z Score Talla:</strong> {resumenIngreso?.pedZScoreTalla}</td>
                  <td width='18%'><strong>Z Score Peso:</strong> {resumenIngreso?.pedZScorePeso}</td>
                  <td width='62%' colSpan={2}><strong>Z Score IMC:</strong> {resumenIngreso?.pedZScoreIMC}</td>
                </tr>
              </table>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr>
                  <td width='50%' style={{ borderTop: '0' }}><strong>Diagnóstico nutricional por ind. Antropométricos:</strong> {resumenIngreso?.idComboRIValorPedDiagnosticoNutricional}</td>
                  <td width='50%' style={{ borderTop: '0' }}><strong>Meta del soporte nutricional:</strong> {resumenIngreso?.idComboRIValorPedMetaSoporteNutricional}</td>
                </tr>
                <tr>
                  <td width='100%' colSpan={2}><strong>Requerimientos extra nutricionales:</strong>
                    {
                      resumenIngreso?.requerimientosExtraNutricionalesRI != null && resumenIngreso?.requerimientosExtraNutricionalesRI.map((req) => {
                        return ' - ' + req;
                      })
                    }
                  </td>
                </tr>
                <tr style={{ display: progSeleccAbrev.some((p) => !['CP', 'CD', 'KETO'].includes(p)) ? 'block' : 'none' }}>
                  <td width='100%' colSpan={2}><strong>Justificación Soporte:</strong>
                    {
                      resumenIngreso?.justificacionSoporteRI != null && resumenIngreso?.justificacionSoporteRI.map((req) => {
                        return ' - ' + req;
                      })
                    }
                  </td>
                </tr>
              </table>
            </div>
          </div>

          {progSeleccAbrev.length > 0 &&
            progSeleccAbrev.map((req) => {
              if (req == 'AE' || req == 'SSAE' || req == 'CEAE') {
                return (
                  <>
                    {req == 'AE' && <div className='pr-seccion-titulo'>Programa Alimentación Enteral</div>}
                    {req == 'SSAE' && <div className='pr-seccion-titulo'>Solo Servicio Alimentación Enteral</div>}
                    {req == 'CEAE' && <div className='pr-seccion-titulo'>Cetogénico Alimentación Enteral</div>}
                    {req == 'AE' &&
                      <div className='pr-tabla' style={{ width: '100%' }}>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td><strong>Karnofsky:</strong> {resumenIngreso?.comboRIValorKarnofskyAE}</td>
                          </tr>
                        </table>
                      </div>
                    }
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Requerimientos</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='20%'><strong>Proteínas Totales/d:</strong> {resumenIngreso?.proteinasTotalesAE}</td>
                          <td width='80%'><strong>Calorías Totales/d:</strong> {resumenIngreso?.caloriasTotalesAE}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Accesos enterales</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='20%'><strong>Tipo de Acceso :</strong> {resumenIngreso?.comboRIValorTipoAccesoAE}</td>
                          <td width='40%'><strong>Cambio de SNG en Domicilio? :</strong> {resumenIngreso?.cambioSNGdomicilio ? 'SI' : 'NO'}</td>
                          <td width='40%'><strong>Acceso enteral en buen estado? :</strong> {resumenIngreso?.accesoBuenEstado ? 'SI' : 'NO'}</td>
                        </tr>
                      </table>
                    </div>
                    {!!resumenIngreso?.indicacionesAE?.length && <>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                      <div className='pr-tabla' style={{ width: '100%' }}>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td class='pr-th' width='60%'>Producto</td>
                            <td class='pr-th' width='20%'>Cantidad diaria</td>
                            <td class='pr-th' width='20%'>Unidad</td>
                          </tr>
                          {
                            resumenIngreso?.indicacionesAE != null && resumenIngreso?.indicacionesAE.map((indicacion) => {
                              return <tr><td>{indicacion.nombreInsumo}</td><td>{indicacion.cantidadDiaria}</td><td>{indicacion.unidad}</td></tr>;
                            })
                          }
                        </table>
                      </div>
                    </>}
                    <div className='pr-tabla' style={{ width: '100%', paddingTop: '10px' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='50%'><strong>Modo de infusión :</strong> {resumenIngreso?.comboRIValorModoInfusionAE}</td>
                          <td width='50%'><strong>Lleva bomba :</strong> {resumenIngreso?.llevaBomba != null ? resumenIngreso?.llevaBomba ? 'SI' : 'NO' : ''}</td>
                        </tr>
                      </table>
                    </div>
                    {req === 'CEAE' && <>
                      <div className='pr-seccion-titulo'>Recomendación de Profesionales</div>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de seguimiento</div>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td>
                            {
                              resumenIngreso?.profesionalRI != null && resumenIngreso?.profesionalRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                      </table>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de especialistas</div>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td>
                            {
                              resumenIngreso?.profesionalEspecialidadRI != null && resumenIngreso?.profesionalEspecialidadRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                      </table>
                    </>}
                  </>);

              } else if (req == 'CP') {
                return (
                  <>
                    <div className='pr-seccion-titulo'>Programa Cuidados Paliativos</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Vida Personal</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='50%'><strong>¿Posee directivas anticipadas? :</strong> {resumenIngreso?.directivasAnticipadas ? 'SI' : 'NO'}</td>
                          <td width='50%'><strong>Subir directivas:</strong> {resumenIngreso?.directivasAdjunto?.titulo}</td>
                        </tr>
                        <tr>
                          <td><strong>Creencia o Religión:</strong> {resumenIngreso?.religion}</td>
                          <td><strong>Pasatiempos:</strong> {resumenIngreso?.pasatiempo}</td>
                        </tr>
                        <tr>
                          <td><strong>Profesión/Ocupación:</strong> {resumenIngreso?.profesionOcupacion}</td>
                          <td><strong>¿Cuidador principal? :</strong> {resumenIngreso?.cuidadorPrincipal}</td>
                        </tr>
                        <tr>
                          <td><strong>Médico de cabecera:</strong> {resumenIngreso?.medicoCabecera}</td>
                          <td><strong>Otros estudios:</strong> {resumenIngreso?.otrosEstudios}</td>
                        </tr>
                        <tr style={{ display: resumenIngreso?.enfermedadOncologica ? 'block' : 'none' }}>
                          <td colSpan={2}><strong>ECOG:</strong> {resumenIngreso?.comboRIValorECOG}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Estudios complementarios</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th'>Nombre del estudio</td>
                        </tr>
                        {
                          resumenIngreso?.estudioAdjunto != null && resumenIngreso?.estudioAdjunto.map((estudio) => {
                            return <tr><td>{estudio.titulo}</td></tr>;
                          })
                        }
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Hábitos</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>Tabaquismo:</strong> {resumenIngreso?.comboRIValorTabaquismo}</td>
                          <td width='33%'><strong>Antecedentes de alcoholismo:</strong> {resumenIngreso?.antecedenteAlcoholismo ? 'SI' : 'NO'}</td>
                          <td width='34%'><strong>Antecedentes de consumo de sustancias:</strong> {resumenIngreso?.antecedenteConsumoSustancias ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Tipo de sustancia:</strong> {resumenIngreso?.descSustancia}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Examen físico</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='25%'><strong>Tensión Arterial:</strong> {resumenIngreso?.tensionArterial}</td>
                          <td width='25%'><strong>Frec. Cardiaca (L/min):</strong> {resumenIngreso?.frecCardiaca}</td>
                          <td width='25%'><strong>Frec. Respiratoria (R/min):</strong> {resumenIngreso?.frecRespiratoria}</td>
                          <td width='25%'><strong>Temperatura:</strong> {resumenIngreso?.temperatura}</td>
                        </tr>
                        <tr>
                          <td><strong>Piel/mucosas/faneras:</strong> {resumenIngreso?.pielMucosasFaneras}</td>
                          <td><strong>SNC:</strong> {resumenIngreso?.sNC}</td>
                          <td><strong>CV:</strong> {resumenIngreso?.cV}</td>
                          <td><strong>Respiratorio:</strong> {resumenIngreso?.respiratorio}</td>
                        </tr>
                        <tr>
                          <td><strong>Digestivo:</strong> {resumenIngreso?.digestivo}</td>
                          <td><strong>Otros:</strong> {resumenIngreso?.otros}</td>
                          <td><strong>Sonda vesical:</strong> {resumenIngreso?.sondaVesicalCP ? 'SI' : 'NO'}</td>
                          <td><strong>Catéter:</strong> {resumenIngreso?.cateterCP ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td><strong>Videodeglución:</strong> {resumenIngreso?.videodeglucionCP ? 'SI' : 'NO'}</td>
                          <td colSpan={3}><strong>Subir Videodeglución:</strong> {resumenIngreso?.videodeglucionCP?.titulo}</td>
                        </tr>
                        <tr>
                          <td><strong>Sonda nasogástrica:</strong> {resumenIngreso?.sondaNasogastricaCP ? 'SI' : 'NO'}</td>
                          <td><strong>Requiere Soporte Nutricional:</strong> {resumenIngreso?.soporteNutricionalCP ? 'SI' : 'NO'}</td>
                          <td><strong>ESAS:</strong> {resumenIngreso?.aduESAS ? 'Si' : 'No corresponde'}</td>
                          <td><strong>Resultado ESAS:</strong> {resumenIngreso?.resultadoAduESAS}</td>
                        </tr>
                      </table>
                    </div>
                    {
                      resumenIngreso?.resultadoAduESASResumido && <>
                        <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Detalle Resultado ESAS</div>
                        <div className='pr-tabla' style={{ width: '100%' }}>
                          <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                            <tr>
                              <td width='100%'>{resumenIngreso?.resultadoAduESASResumido}</td>
                            </tr>
                          </table>
                        </div>
                      </>
                    }
                    {resumenIngreso.edadAnios <= 15 && <>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Paciente Pediatrico</div>
                      <div className='pr-tabla' style={{ width: '100%' }}>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          {resumenIngreso?.idComboRIValorPedLANSKYCP && <tr>
                            <td colSpan={12}><strong>Escala LANSKY:</strong> {resumenIngreso?.idComboRIValorPedLANSKYCP || '-'}</td>
                          </tr>}
                          <tr>
                            <td colSpan={3}><strong>ESCALA GMFS:</strong> {resumenIngreso?.pedGMFS ? 'Si' : 'No corresponde'}</td>
                            <td colSpan={9}><strong>resultado GMFS:</strong> {resumenIngreso?.resultadoPedGMFS || '-'}</td>
                          </tr>
                          <tr>
                            <td colSpan={12}><strong>Escala de Dolor:</strong> {resumenIngreso?.idComboRIValorPedEscalaDolorCP}</td>
                          </tr>
                          {resumenIngreso?.idComboRIValorPedEscalaDolorCP === 'Si' && <>
                            <tr>
                              <td colSpan={6}><strong>Escala FLACC-R:</strong> {resumenIngreso?.pedFLACCR ? 'Si' : 'No corresponde'}</td>
                              <td colSpan={6}><strong>Resultado escala FLACC-R:</strong> {resumenIngreso?.resultadoPedFLACCR || '-'}</td>
                            </tr>
                            <tr>
                              <td colSpan={6}><strong>Escala Gustave-Roussy:</strong> {resumenIngreso?.pedGustaveRoussy ? 'Si' : 'No corresponde'}</td>
                              <td colSpan={6}><strong>Resultado escala Gustave-Roussy:</strong> {resumenIngreso?.resultadoPedGustaveRoussy || '-'}</td>
                            </tr>
                            <tr>
                              <td colSpan={6}><strong>Escala FPS-R:</strong> {resumenIngreso?.pedFPSR ? 'Si' : 'No corresponde'}</td>
                              <td colSpan={6}><strong>Resultado escala FPS-R:</strong> {resumenIngreso?.resultadoPedFPSR || '-'}</td>
                            </tr>
                            <tr>
                              <td colSpan={6}><strong>Escala numérica de Dolor:</strong> {resumenIngreso?.escalaNumericaDolor ? 'Si' : 'No corresponde'}</td>
                              <td colSpan={6}><strong>Resultado escala Escala numérica de Dolor:</strong> {resumenIngreso?.resultadoEscalaNumericaDolor || '-'}</td>
                            </tr>
                          </>}
                        </table>
                      </div>
                    </>}
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Situación socio-familiar</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>¿Vive solo? :</strong> {resumenIngreso?.viveSolo ? 'SI' : 'NO'}</td>
                          <td width='33%'><strong>¿Tiene cuidadores contratados? :</strong> {resumenIngreso?.cuidadoresContratados ? 'SI' : 'NO'}</td>
                          <td width='34%'><strong>¿Existe claudicación familiar? :</strong> {resumenIngreso?.claudicacionFamiliar ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td width='100%' colSpan={3}><strong>Otros datos socioeconómicos o familiares:</strong> {resumenIngreso?.datosSocioEcoFamiliares}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Situación de información del paciente y la familia</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='50%'><strong>¿Posee información diagnóstica? :</strong> {resumenIngreso?.comboRIValorPoseeInfDiagnosticaCP}</td>
                          <td width='50%'><strong>¿Posee información sobre el pronóstico? :</strong> {resumenIngreso?.comboRIValorPoseeInfPronosticoCP}</td>
                        </tr>
                        <tr>
                          <td><strong>¿Pide información sobre la enfermedad? :</strong> {resumenIngreso?.comboRIValorPoseeInfEnfermedadCP}</td>
                          <td><strong>¿Nombra la palabra cáncer? :</strong> {resumenIngreso?.comboRIValorNombraPalabraCancerCP}</td>
                        </tr>
                        <tr>
                          <td><strong>¿Hay cerco de silencio? :</strong> {resumenIngreso?.comboRIValorCercoDeSilencioCP}</td>
                          <td><strong>¿Existe trastorno de adaptación? :</strong> {resumenIngreso?.comboRIValorTrastornoAdaptacionCP}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}><strong>Otros datos de información relevantes:</strong> {resumenIngreso?.otrosDatosInformacion}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Tratamiento actual</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th'>Tratamiento</td>
                        </tr>
                        {
                          resumenIngreso?.cPMedicacionDosificacionRI != null && resumenIngreso?.cPMedicacionDosificacionRI.map((reg) => {
                            return <tr><td>{reg.descripcion}</td></tr>;
                          })
                        }
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Problemas principales a tratar</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td><strong>Físicos:</strong> {resumenIngreso?.problemaFisico}</td>
                        </tr>
                        <tr>
                          <td><strong>Psicológicos:</strong> {resumenIngreso?.problemaPsicologico}</td>
                        </tr>
                        <tr>
                          <td><strong>Sociales:</strong> {resumenIngreso?.problemaSocial}</td>
                        </tr>
                        <tr>
                          <td><strong>Espirituales:</strong> {resumenIngreso?.problemaEspiritual}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th' width='50%'>Medicamento</td>
                          <td class='pr-th' width='40%'>Presentación</td>
                          <td class='pr-th' width='10%'>Dosis</td>
                        </tr>
                        {
                          resumenIngreso?.indicacionesCP != null && resumenIngreso?.indicacionesCP.map((reg) => {
                            return <tr><td>{reg.nombreInsumo}</td><td>{reg.presentacion}</td><td>{reg.cantidadDiaria}</td></tr>;
                          })
                        }
                      </table>
                      <br />
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td><strong>Requerimientos:</strong> {resumenIngreso?.otrasIndicacionesCP}</td>
                        </tr>
                      </table>
                    </div>
                    <div style={{ display: !soloCP ? 'block' : 'none' }}>
                      <div className='pr-seccion-titulo'>Recomendación de Profesionales</div>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de seguimiento</div>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td>
                            {
                              resumenIngreso?.profesionalRI != null && resumenIngreso?.profesionalRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                      </table>
                    </div>
                    {
                      mostrarEspecialistas && <>
                        <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de especialistas</div>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td>
                              {
                                resumenIngreso?.profesionalEspecialidadRI != null && resumenIngreso?.profesionalEspecialidadRI.map((reg) => {
                                  return ' - ' + reg;
                                })
                              }
                            </td>
                          </tr>
                        </table>
                      </>
                    }
                    {
                      resumenIngreso?.requerimientosAdicionales != null &&
                      resumenIngreso?.requerimientosAdicionales.length > 0 && <>
                        <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Requerimientos adicionales</div>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td>
                              {
                                resumenIngreso?.requerimientosAdicionales.map((reg) => {
                                  return ' - ' + reg;
                                })
                              }
                            </td>
                          </tr>
                        </table>
                      </>
                    }
                  </>);

              } else if (req == 'KETO') {
                return (
                  <>
                    <div className='pr-seccion-titulo'>Programa Ketosteril</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Criterios de inclusión</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>ERC estadio:</strong> {resumenIngreso?.idComboRIValorERCestadio}</td>
                          <td width='33%'><strong>Paciente en hemodiálisis incremental:</strong> {resumenIngreso?.hemodialisisIncremental ? 'SI' : 'NO'}</td>
                          <td width='34%'><strong>Paciente no quiere dializar:</strong> {resumenIngreso?.quiereDialisis ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td width='33%'><strong>Paciente post tx renal con deterioro:</strong> {resumenIngreso?.txrenalConDeterioro ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>Paciente en recuperación renal que sale de diálisis:</strong> {resumenIngreso?.recuperacionRenalDialisis ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td width='33%'><strong>FG (MDRD/CKD-EPI):</strong> {resumenIngreso?.fG}</td>
                          <td colSpan={2}><strong>Laboratorio:</strong> {resumenIngreso?.laboratorioKETO}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Documento:</strong> {resumenIngreso?.laboratorioAdjuntoKETO?.titulo}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th' width='60%'>Producto</td>
                          <td class='pr-th' width='20%'>Cantidad diaria</td>
                          <td class='pr-th' width='20%'>Unidad</td>
                        </tr>
                        {
                          resumenIngreso?.indicacionesKeto != null && resumenIngreso?.indicacionesKeto.map((indicacion) => {
                            return <tr><td>{indicacion.nombreInsumo}</td><td>{indicacion.cantidadDiaria}</td><td>{indicacion.unidad}</td></tr>;
                          })
                        }
                      </table>
                    </div>
                  </>);

              } else if (req == 'AP') {
                return (
                  <>
                    <div className='pr-seccion-titulo'>Programa Alimentación Parenteral</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Paciente Adulto</div>
                    {
                      resumenIngreso.edadAnios > 15 &&
                      <div className='pr-tabla' style={{ width: '100%' }}>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td><strong>Karnofsky:</strong> {resumenIngreso?.comboRIValorKarnofsky}</td>
                          </tr>
                        </table>
                      </div>
                    }
                    {
                      resumenIngreso.edadAnios <= 15 &&
                      <div className='pr-tabla' style={{ width: '100%' }}>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td><strong>GER Formula de Schofield:</strong> {resumenIngreso?.formulaSchofieldPed}</td>
                          </tr>
                        </table>
                      </div>
                    }
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Requerimientos</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='25%'><strong>Calorías /kg/d:</strong> {resumenIngreso?.calorias}</td>
                          <td width='25%'><strong>Hidratos de Carbono /kg/d:</strong> {resumenIngreso?.hidratosCarbono}</td>
                          <td width='25%'><strong>Proteínas /kg/d:</strong> {resumenIngreso?.proteinas}</td>
                          <td width='25%'><strong>Lípidos /kg/d:</strong> {resumenIngreso?.lipidos}</td>
                        </tr>
                        <tr>
                          <td><strong>Proteínas totales /d:</strong> {resumenIngreso?.proteinasTotalesAP}</td>
                          <td><strong>Lípidos totales /d:</strong> {resumenIngreso?.lipidosTotalesAP}</td>
                          <td colSpan={2}><strong>Calorías totales /d:</strong> {resumenIngreso?.caloriasTotalesAP}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Último Laboratorio</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td><strong>Laboratorio:</strong> {resumenIngreso?.laboratorioAP}</td>
                        </tr>
                        <tr>
                          <td><strong>Documento:</strong> {resumenIngreso?.laboratorioAdjunto?.titulo}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Accesos Parenteral</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='25%'><strong>Tipo de Catéter:</strong> {resumenIngreso?.comboRIValorTipoCateter}</td>
                          <td width='25%'><strong>Fecha de colocación:</strong> {resumenIngreso?.fechaColocacionCateter}</td>
                          <td width='25%'><strong>Ubicación de catéter:</strong> {resumenIngreso?.comboRIValorUbicacionCateter}</td>
                          <td width='25%'><strong>N° de lúmenes:</strong> {resumenIngreso?.comboRIValorNroLumenes}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}><strong>Justificar si es Transitorio:</strong> {resumenIngreso?.justificarTipoCateter}</td>
                          <td colSpan={2}><strong>¿Sitio de inserción del catéter normal? :</strong> {resumenIngreso?.insercionCateterNormal ? 'SI' : 'NO'}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='30%'><strong>BAP Magistral:</strong> {resumenIngreso?.magistral ? 'SI' : 'NO'}</td>
                          <td width='70%' colSpan={2}><strong>Volumen:</strong> {resumenIngreso?.volumenMagistral}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Conexiones por semana:</strong>
                            {
                              resumenIngreso?.diasConexionSemanaMagistralAP != null && resumenIngreso?.diasConexionSemanaMagistralAP.map((dia) => {
                                return ' - ' + dia;
                              })
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong>BAP Estándar:</strong> {resumenIngreso?.bAPestandar ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>¿Cuál? :</strong> {resumenIngreso?.nombreInsumoAP}</td>
                        </tr>
                        <tr>
                          <td><strong>Cantidad diaria:</strong> {resumenIngreso?.cantidadDiariaAP}</td>
                          <td colSpan={2}><strong>Motivo de la indicación Estándar:</strong> {resumenIngreso?.comboRIValorMotivoIndicacionEstandar}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Conexiones por semana:</strong>
                            {
                              resumenIngreso?.diasConexionSemanaAP != null && resumenIngreso?.diasConexionSemanaAP.map((dia) => {
                                return ' - ' + dia;
                              })
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong>¿Requiere BAP magistral adelantada?:</strong> {resumenIngreso?.bAPxAdelantado ? 'SI' : 'NO'}</td>
                          <td><strong>Modo de infusión:</strong> {resumenIngreso?.comboRIValorModoInfusion}</td>
                          <td><strong>Sellado de catéter:</strong> {resumenIngreso?.comboRIValorSelladoCateter}</td>
                        </tr>
                      </table>
                    </div>
                  </>);

              } else if (req == 'AO' || req == 'CEAO' || req == 'AOC') {
                return (
                  <>
                    {req == 'AO' && <div className='pr-seccion-titulo'>Programa Alimentación Oral</div>}
                    {req == 'CEAO' && <div className='pr-seccion-titulo'>Programa Cetogénico Alimentación Oral</div>}
                    {req == 'AOC' && <div className='pr-seccion-titulo'>Programa Alimentación Oral Compleja</div>}
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th' width='60%'>Producto</td>
                          <td class='pr-th' width='20%'>Cantidad diaria</td>
                          <td class='pr-th' width='20%'>Unidad</td>
                        </tr>
                        {
                          resumenIngreso?.indicacionesAO != null && resumenIngreso?.indicacionesAO.map((indicacion) => {
                            return <tr><td>{indicacion.nombreInsumo}</td><td>{indicacion.cantidadDiaria}</td><td>{indicacion.unidad}</td></tr>;
                          })
                        }
                      </table>
                    </div>
                    {(req == 'CEAO' || req == 'AOC') && <>
                      <div className='pr-seccion-titulo'>Recomendación de Profesionales</div>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de seguimiento</div>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td>
                            {
                              resumenIngreso?.profesionalRI != null && resumenIngreso?.profesionalRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                      </table>
                      <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de especialistas</div>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td>
                            {
                              resumenIngreso?.profesionalEspecialidadRI != null && resumenIngreso?.profesionalEspecialidadRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                      </table>
                    </>}
                  </>);

              } else if (req == 'NPID' || req == 'SIP') {
                return <>
                  <div className='pr-seccion-titulo'>Programa {req === 'NPID' ? 'Intradiálisis' : 'Solo Insumos Parenteral'}</div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Paciente Adulto</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td><strong>Karnofsky:</strong> {resumenIngreso?.comboRIValorKarnofskyNPID}</td>
                      </tr>
                    </table>
                  </div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Requerimientos</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td width='33%'><strong>Proteínas totales /d:</strong> {resumenIngreso?.proteinasTotalesNPID}</td>
                        <td width='33%'><strong>Lípidos totales /d:</strong> {resumenIngreso?.lipidosTotalesNPID}</td>
                        <td width='34%'><strong>Calorías totales /d:</strong> {resumenIngreso?.caloriasTotalesNPID}</td>
                      </tr>
                    </table>
                  </div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Examen Físico</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td><strong>Presencia de edemas:</strong> {resumenIngreso?.presenciaEdemas ? 'SI' : 'NO'}</td>
                      </tr>
                    </table>
                  </div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Último Laboratorio</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td><strong>Laboratorio:</strong> {resumenIngreso?.laboratorioNPID}</td>
                      </tr>
                      <tr>
                        <td><strong>Documento:</strong> {resumenIngreso?.laboratorioAdjuntoNPID?.titulo}</td>
                      </tr>
                    </table>
                  </div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Accesos</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td width='25%'><strong>FAV:</strong> {resumenIngreso?.comboRIValorFAV}</td>
                        <td width='25%'><strong>Catéter:</strong> {resumenIngreso?.comboRIValorTipoCateter}</td>
                        <td width='25%'><strong>Fecha de colocación:</strong> {resumenIngreso?.fechaColocacionNPID}</td>
                        <td width='25%'><strong>Ubicación de catéter:</strong> {resumenIngreso?.comboRIValorUbicacionNPID}</td>
                      </tr>
                      <tr>
                        <td width='25%'><strong>N° de lúmenes:</strong> {resumenIngreso?.comboRIValorNroLumenesNPID}</td>
                        <td width='25%'><strong>¿Sitio de inserción del catéter normal?:</strong> {resumenIngreso?.cateterNormalNPID ? 'SI' : 'NO'}</td>
                      </tr>
                    </table>
                  </div>
                  <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                  <div className='pr-tabla' style={{ width: '100%' }}>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td width='33%'><strong>BAP Estándar:</strong> {resumenIngreso?.bAPestandarNPID ? 'SI' : 'NO'}</td>
                        <td width='33%'><strong>¿Cuál?:</strong> {resumenIngreso?.nombreInsumoNPID}</td>
                        <td width='34%'><strong>Cantidad diaria:</strong> {resumenIngreso?.cantidadDiariaNPID}</td>
                      </tr>
                      <tr>
                        <td colSpan={3}><strong>Conexiones por semana:</strong>
                          {
                            resumenIngreso?.diasConexionSemanaNPID != null && resumenIngreso?.diasConexionSemanaNPID.map((dia) => {
                              return ' - ' + dia;
                            })
                          }
                        </td>
                      </tr>
                      <tr>
                        <td width='33%'><strong>BAP Magistral:</strong> {resumenIngreso?.magistralNPID ? 'SI' : 'NO'}</td>
                        <td width='33%'><strong>Volumen:</strong> {resumenIngreso?.volumenMagistralNPID}</td>
                        <td width='34%'><strong>Motivo de la indicación Magistral:</strong> {resumenIngreso?.comboRIValorMotivoIndicacionMagistralNPID}</td>
                      </tr>
                      <tr>
                        <td colSpan={3}><strong>Conexiones por semana:</strong>
                          {
                            resumenIngreso?.diasConexionSemanaMagistralNPID != null && resumenIngreso?.diasConexionSemanaMagistralNPID.map((dia) => {
                              return ' - ' + dia;
                            })
                          }
                        </td>
                      </tr>
                    </table>
                  </div>
                </>;
              } else if (req == 'DI') {
                return (
                  <>
                    <div className='pr-seccion-titulo'>Programa Disfagia</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Alimentación</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td><strong>Videodeglución:</strong> {resumenIngreso?.videodeglucion ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>Disfagia a:</strong>
                            {
                              resumenIngreso?.dIDisfagiaARI != null && resumenIngreso?.dIDisfagiaARI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Episodios anteriores de neumonía:</strong> {resumenIngreso?.episodiosNeumonia ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>Alimentación actual:</strong>
                            {
                              resumenIngreso?.dIAlimentacionActualRI != null && resumenIngreso?.dIAlimentacionActualRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Hidratación actual:</strong>
                            {
                              resumenIngreso?.dIHidratacionActualRI != null && resumenIngreso?.dIHidratacionActualRI.map((reg) => {
                                return ' - ' + reg;
                              })
                            }
                          </td>
                        </tr>
                        <tr>
                          <td width='33%'><strong>Traqueostomía:</strong> {resumenIngreso?.traqueostomia ? 'SI' : 'NO'}</td>
                          <td width='33%'><strong>Lúcido:</strong> {resumenIngreso?.lucido ? 'SI' : 'NO'}</td>
                          <td width='34%'><strong>Compromiso motor:</strong> {resumenIngreso?.compromisoMotor ? 'SI' : 'NO'}</td>
                        </tr>
                      </table>
                    </div>

                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicación</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>Nada por boca:</strong> {resumenIngreso?.nadaPorBoca}</td>
                          <td width='33%'><strong>Justificación:</strong> {resumenIngreso?.justificacionNadaPorBoca}</td>
                          <td width='33%'><strong>Hidratación:</strong> {resumenIngreso?.comboRIValorHidratacion}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Indicaciones</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td class='pr-th' width='60%'>Producto</td>
                          <td class='pr-th' width='20%'>Cantidad diaria</td>
                          <td class='pr-th' width='20%'>Unidad</td>
                        </tr>
                        {
                          resumenIngreso?.indicacionesDI != null && resumenIngreso?.indicacionesDI.map((indicacion) => {
                            return <tr><td>{indicacion.nombreInsumo}</td><td>{indicacion.cantidadDiaria}</td><td>{indicacion.unidad}</td></tr>;
                          })
                        }
                      </table>
                    </div>
                  </>);

              } else if (req == 'CD') {
                return (
                  <>
                    <div className='pr-seccion-titulo'>Programa Cuidados Domiciliarios</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Examen Físico</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td colSpan={2}><strong>SNC:</strong> {resumenIngreso?.sNCCD}</td>
                          <td colSpan={2}><strong>CV:</strong> {resumenIngreso?.cVCD}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}><strong>Respiratorio:</strong> {resumenIngreso?.respiratorioCD}</td>
                          <td colSpan={2}><strong>Digestivo:</strong> {resumenIngreso?.digestivoCD}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}><strong>Videodeglución:</strong> {resumenIngreso?.videodeglucionCD ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>Subir Videodeglución:</strong> {resumenIngreso?.videodeglucionCD?.titulo}</td>
                        </tr>
                        <tr>
                          <td colSpan={4}><strong>Otros:</strong> {resumenIngreso?.otrosCD}</td>
                        </tr>
                        <tr>
                          <td width='25%'><strong>Traqueostomía:</strong> {resumenIngreso?.traqueostomiaCD ? 'SI' : 'NO'}</td>
                          <td width='25%'><strong>Sonda vesical:</strong> {resumenIngreso?.sondaVesicalCD ? 'SI' : 'NO'}</td>
                          <td width='25%'><strong>Ostomía:</strong> {resumenIngreso?.ostomiaCD ? 'SI' : 'NO'}</td>
                          <td width='25%'><strong>Catéter:</strong> {resumenIngreso?.cateterCD ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td width='25%'><strong>Sonda nasogástrica:</strong> {resumenIngreso?.sondaNasogastricaCD ? 'SI' : 'NO'}</td>
                          <td colSpan={3}><strong>Calendario vacunas completo:</strong> {resumenIngreso?.idComboRIValorCalendarioVacunasCD}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}><strong>Karnofsky:</strong> {resumenIngreso?.idComboRIValorAduKarnofskyCD}</td>
                          <td colSpan={2}><strong>Escala LANSKY:</strong> {resumenIngreso?.idComboRIValorPedLANSKYCD}</td>
                        </tr>
                        <tr>
                          <td colSpan={4}><strong>Requiere Soporte Nutricional:</strong> {resumenIngreso?.requiereSoporteNutricionalCD ? 'SI' : 'NO'}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Hábitos</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>Tabaquismo:</strong> {resumenIngreso?.idComboRIValorTabaquismoCD}</td>
                          <td width='33%'><strong>Antecedentes de alcoholismo:</strong> {resumenIngreso?.antecedentesAlcoholismo ? 'SI' : 'NO'}</td>
                          <td width='34%'><strong>Antecedentes de consumo de sustancias:</strong> {resumenIngreso?.antecedenteConsumoSustanciaCD ? 'SI' : 'NO'}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Tipo de sustancia:</strong> {resumenIngreso?.tipoSustancia || '-'}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Infusión de Drogas</div>
                    <div className='pr-tabla' style={{ width: '100%' }}>
                      <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                        <tr>
                          <td width='33%'><strong>Infusión de Drogas:</strong> {resumenIngreso?.infusionDrogas ? 'SI' : 'NO'}</td>
                          <td colSpan={2}><strong>¿Droga a Infundir? :</strong> {resumenIngreso?.drogasAInfundir}</td>
                        </tr>
                        <tr>
                          <td width='33%'><strong>Dosis:</strong> {resumenIngreso?.dosis}</td>
                          <td width='33%'><strong>Frecuencia:</strong> {resumenIngreso?.frecuencia}</td>
                          <td width='34%'><strong>¿Cumple criterios de ingreso? :</strong> {resumenIngreso?.cumpleCriterioIngreso}</td>
                        </tr>
                        <tr>
                          <td><strong>Realizó infusiones previas:</strong> {resumenIngreso?.infusionesPrevias ? 'SI' : 'NO'}</td>
                          <td><strong>Cuántas:</strong> {resumenIngreso?.cuantas}</td>
                          <td><strong>Dónde:</strong> {resumenIngreso?.donde}</td>
                        </tr>
                        <tr>
                          <td colSpan={3}><strong>Presentó reacciones adversas:</strong> {resumenIngreso?.reaccionesAdversas}</td>
                        </tr>
                      </table>
                    </div>
                    <div className='pr-seccion-titulo'>Recomendación de Profesionales</div>
                    <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de seguimiento</div>
                    <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                      <tr>
                        <td>
                          {
                            resumenIngreso?.profesionalRI != null && resumenIngreso?.profesionalRI.map((reg) => {
                              return ' - ' + reg;
                            })
                          }
                        </td>
                      </tr>
                    </table>
                    {
                      mostrarEspecialistas && <>
                        <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Equipo de especialistas</div>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td>
                              {
                                resumenIngreso?.profesionalEspecialidadRI != null && resumenIngreso?.profesionalEspecialidadRI.map((reg) => {
                                  return ' - ' + reg;
                                })
                              }
                            </td>
                          </tr>
                        </table>
                      </>
                    }
                    {
                      resumenIngreso?.requerimientosAdicionales != null &&
                      resumenIngreso?.requerimientosAdicionales.length > 0 && <>
                        <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Requerimientos adicionales</div>
                        <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                          <tr>
                            <td>
                              {
                                resumenIngreso?.requerimientosAdicionales.map((reg) => {
                                  return ' - ' + reg;
                                })
                              }
                            </td>
                          </tr>
                        </table>
                      </>
                    }
                  </>);

              }
            })
          }

          {/* Condiciones Generales */}
          <div className='pr-seccion-titulo'>Condiciones Generales</div>
          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Condiciones del paciente para el inicio</div>
          <div className='pr-tabla' style={{ width: '100%' }}>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                <td width='50%'><strong>Buena tolerancia al volumen y ritmo de infusión:</strong> {resumenIngreso?.buenaTolerancia}</td>
                <td width='50%'><strong>¿Debe continuar con otros tratamientos?:</strong> {resumenIngreso?.continuarOtroTratamiento ? 'SI' : 'NO'}</td>
              </tr>
              <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                <td colSpan={2}><strong>¿Al momento de confeccionar este documento el paciente se encuentra en condiciones de iniciar el SND?:</strong> {resumenIngreso?.inicioDeServicio}</td>
              </tr>
              <tr style={{ display: soloCP ? 'block' : 'none' }}>
                <td colSpan={2}><strong>¿El paciente requiere Soporte Nutricional?:</strong> {resumenIngreso?.inicioDeServicio}</td>
              </tr>
              <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                <td width='50%'><strong>¿El paciente posee dispositivos para telemedicina?:</strong> {resumenIngreso?.dispositivoParaVideoConf ? 'SI' : 'NO'}</td>
                <td width='50%'><strong>Fase del paciente al inicio:</strong> {resumenIngreso?.idComboRIValorFasePaciente}</td>
              </tr>
              <tr style={{ display: soloCP ? 'block' : 'none' }}>
                <td width='100%' colSpan={2}><strong>¿El paciente posee dispositivos para telemedicina?:</strong> {resumenIngreso?.dispositivoParaVideoConf ? 'SI' : 'NO'}</td>
              </tr>
            </table>
          </div>

          {/* Lugar RI en Domicilio */}
          <div style={{ display: resumenIngreso?.comboRIValorLugarRI === 'Domicilio' ? 'block' : 'none' }}>
            <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Condiciones del domicilio según referencia paciente/cuidador</div>
            <div className='pr-tabla' style={{ width: '100%' }}>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr>
                  <td width='33%'><strong>¿Domicilio accesible?:</strong> {resumenIngreso?.domicilioAccesible ? 'SI' : 'NO'}</td>
                  <td width='33%'><strong>¿Agua potable?:</strong> {resumenIngreso?.aguaPotable ? 'SI' : 'NO'}</td>
                  <td width='34%'><strong>¿Red eléctrica?:</strong> {resumenIngreso?.redElectrica ? 'SI' : 'NO'}</td>
                </tr>
                <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                  <td colSpan={2}><strong>¿Paciente/familiar comprende y acepta el servicio?:</strong> {resumenIngreso?.comprendeAceptaServicio ? 'SI' : 'NO'}</td>
                  <td><strong>¿Higiene del domicilio aceptable?:</strong> {resumenIngreso?.higiene ? 'SI' : 'NO'}</td>
                </tr>
                <tr style={{ display: !soloCP ? 'block' : 'none' }}>
                  <td><strong>¿Lugar seguro para el almacenamiento?:</strong> {resumenIngreso?.almacenamiento ? 'SI' : 'NO'}</td>
                  <td><strong>¿Cuidadores en domicilio?:</strong> {resumenIngreso?.cuidador ? 'SI' : 'NO'}</td>
                  <td><strong>¿Tiene internación domiciliaria?:</strong> {resumenIngreso?.internacionDomiciliaria ? 'SI' : 'NO'}</td>
                </tr>
                <tr style={{ display: soloCP ? 'block' : 'none' }}>
                  <td><strong>¿Cuidadores en domicilio?:</strong> {resumenIngreso?.cuidador ? 'SI' : 'NO'}</td>
                  <td colSpan={2}><strong>¿Tiene internación domiciliaria?:</strong> {resumenIngreso?.internacionDomiciliaria ? 'SI' : 'NO'}</td>
                </tr>
                <tr>
                  <td colSpan={2}><strong>¿Prestación que recibe?:</strong> {resumenIngreso?.prestacion}</td>
                  <td><strong>¿Empresa que se lo realiza?:</strong> {resumenIngreso?.empresa}</td>
                </tr>
                <tr>
                  <td colSpan={3}><strong>Observaciones:</strong> {resumenIngreso?.observaciones}</td>
                </tr>
              </table>
            </div>
          </div>

          {/* Lugar de RI Internación */}
          <div style={{ display: resumenIngreso?.comboRIValorLugarRI !== 'Domicilio' ? 'block' : 'none' }}>
            <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Condiciones de la institución donde se presta el servicio</div>
            <div className='pr-tabla' style={{ width: '100%' }}>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr>
                  <td width='33%'><strong>Cumple condiciones de higiene?:</strong> {resumenIngreso?.higieneInstitucion ? 'SI' : 'NO'}</td>
                  <td width='33%'><strong>Espacio para almacenar insumos?:</strong> {resumenIngreso?.almacenamientoInstitucion ? 'SI' : 'NO'}</td>
                  <td width='34%'><strong>Servicio a cargo del personal de la institución?:</strong> {resumenIngreso?.personalInstitucion ? 'SI' : 'NO'}</td>
                </tr>
              </table>
            </div>
          </div>

          <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Condiciones para brindar el servicio</div>
          <div className='pr-tabla' style={{ width: '100%' }}>
            <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
              <tr>
                <td colSpan={3}><strong>Evaluación del grupo familiar y entorno psicosocial del paciente es adecuada?:</strong> {resumenIngreso?.evaluacionFamiliaPsicosocial ? 'SI' : 'NO'}</td>
              </tr>
              <tr>
                <td colSpan={3}><strong>Conclusión:</strong> {resumenIngreso?.conclusion ? 'APTO' : 'NO APTO'}</td>
              </tr>
              <tr>
                <td width='33%'><strong>Consentimiento Informado:</strong> {resumenIngreso?.consentimientoInformado ? 'SI' : 'NO'}</td>
                <td width='64%'><strong>Fecha de firma:</strong> {resumenIngreso?.fechaFirmaConsentimiento}</td>
              </tr>
            </table>
          </div>
          {
            profesionalRealizoRI != null ? <>
              <div className='pr-seccion-subtitulo' style={{ marginTop: '5px' }}>Profesional que realizó el RI</div>
              <div className='pr-tabla' style={{ width: '100%' }}>
                <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                  <tr>
                    <td width='50%'><strong>Profesional:</strong> {profesionalRealizoRI.apellido} {profesionalRealizoRI.nombre}</td>
                    <td width='50%'>
                      {profesionalRealizoRI?.matriculaNac != "" && profesionalRealizoRI?.matriculaNac != "N/A" &&
                        profesionalRealizoRI?.matriculaProv != "" && profesionalRealizoRI?.matriculaProv != "N/A" &&
                        <>
                          <strong>Matrícula Nacional:</strong> {profesionalRealizoRI?.matriculaNac}
                          <span>&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
                          <strong>Matrícula Provincial:</strong> {profesionalRealizoRI?.matriculaProv}
                        </>
                      }
                      {profesionalRealizoRI?.matriculaNac != "" && profesionalRealizoRI?.matriculaNac != "N/A" && (
                        profesionalRealizoRI?.matriculaProv == "" || profesionalRealizoRI?.matriculaProv == "N/A") &&
                        <>
                          <strong>Matrícula Nacional:</strong> {profesionalRealizoRI?.matriculaNac}
                        </>
                      }
                      {(profesionalRealizoRI?.matriculaNac == "" || profesionalRealizoRI?.matriculaNac == "N/A") &&
                        profesionalRealizoRI?.matriculaProv != "" && profesionalRealizoRI?.matriculaProv != "N/A" &&
                        <>
                          <strong>Matrícula Provincial:</strong> {profesionalRealizoRI?.matriculaProv}
                        </>
                      }
                    </td>
                  </tr>
                </table>
              </div>
              <br /><br />
            </> :
              <><br /><br /></>
          }
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', width: '100%' }}>
            <div className='pr-tabla' style={{ width: '60%' }}>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr><td width='65%' style={{ borderBottom: '0pt', borderRight: '0px' }}><strong>Profesional:</strong> {profesionalCierre?.apellido} {profesionalCierre?.nombre}</td>
                  <td rowSpan={4} class='pr-firma' style={{ borderLeft: '0pt' }}>
                    <img width='100%' height='80' src={firmaProfesional}>
                    </img>
                  </td>
                </tr>
                <tr><td style={{ borderBottom: '0pt', borderTop: '0pt', borderRight: '0px' }}><strong>Matrícula Nacional:</strong> {profesionalCierre?.matriculaNac}</td></tr>
                <tr><td style={{ borderTop: '0pt', borderBottom: '0pt', borderRight: '0px' }}><strong>Matrícula Provincial:</strong> {profesionalCierre?.matriculaProv}</td></tr>
                <tr><td style={{ borderTop: '0pt', borderRight: '0px' }}><strong>Fecha:</strong> {profesionalCierre?.fechaCierreRI != null ? moment(profesionalCierre?.fechaCierreRI).format('DD/MM/yyyy HH:mm') : ''}</td></tr>
                <tr><td colSpan={2} style={{ fontWeight: 800, textAlign: 'center', borderTop: '0px' }}>{profesionalRealizoRI != null ? "Modificado" : "Completado"} por Profesional - Firmado electrónicamente</td></tr>
              </table>
            </div>
            <div className='pr-tabla' style={{ width: '38%', marginLeft: '20px', display: firmaValidador !== "" && profesionalCierre?.idEstadoValidacion === 3 ? 'block' : 'none' }}>
              <table role="presentation" border='0' cellSpacing={0} cellPadding={0} style={{ width: '100%', margin: '0', padding: '0' }}>
                <tr>
                  <td class='pr-firma' style={{ textAlign: 'center' }}>
                    <img width='55%' height='80' src={firmaValidador}>
                    </img>
                  </td>
                </tr>
                <tr><td style={{ fontWeight: 800, textAlign: 'center', borderTop: '0px' }}>Validado - Firmado electrónicamente</td></tr>
              </table>
            </div>
          </div>
        </div>
      }
    </>);

};

const modulos = [
  {
    displayName: 'Datos Generales',
    key: 'Datos Generales',
    sections: [
      {
        subSections: [
          {
            title: 'Programa tipo',
            elements: [
              {
                displayName: '',
                name: 'selectedPrograms',
                col: 12
              }]

          },
          {
            title: 'Datos filiatorios',
            elements: [
              {
                displayName: 'N° HC',
                name: 'hC',
                col: 3
              },
              {
                displayName: 'Nombre',
                name: 'nombre',
                col: 3
              },
              {
                displayName: 'Apellido',
                name: 'apellido',
                col: 3
              },
              {
                displayName: 'DNI N°',
                name: 'dNI',
                col: 3
              },
              {
                displayName: 'Fecha nacimiento',
                name: 'fechaNacimiento',
                col: 3
              },
              {
                displayName: 'Edad',
                name: 'edadAnios',
                col: 3
              },
              {
                displayName: 'Sexo',
                name: 'sexo',
                col: 3
              },
              {
                displayName: 'Domicilio',
                name: 'domicilio',
                col: 3
              },
              {
                displayName: 'Financiador',
                name: 'financiador',
                col: 3
              },
              {
                displayName: 'N° afiliado',
                name: 'nroAfiliado',
                col: 3
              },
              {
                displayName: 'Tel. de contacto',
                name: 'telContacto',
                col: 3
              },
              {
                displayName: 'Familiar de contacto',
                name: 'familiarContacto',
                col: 3
              },
              {
                displayName: 'Tel Familiar',
                name: 'telFamiliar',
                col: 3
              },
              {
                displayName: 'Médico de contacto',
                name: 'medicoPrescriptor',
                col: 3
              },
              {
                displayName: 'Lugar donde se prestara el servicio',
                name: 'comboRIValorLugarServicio',
                col: 6
              },
              {
                displayName: 'Centro de referencia',
                name: 'centroReferencia',
                col: 3
              },
              {
                displayName: 'Centro de referencia',
                name: 'codInstitucionReferencia',
                col: 3
              },
              {
                displayName: 'Lugar de RI',
                name: 'comboRIValorLugarRI',
                col: 6
              },
              {
                displayName: '¿Que servicio de emergencia posee?',
                name: 'servicioEmergencia',
                col: 3
              },
              {
                displayName: 'Telefono de Emergencia',
                name: 'telefonoEmergencia',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Resumen de HCL',
            elements: [
              {
                displayName: 'Resumen de HCL',
                name: 'resumenHCL',
                col: 12
              },
              {
                displayName: 'Diagnóstico al alta',
                name: 'diagnosticoAlta',
                col: 12
              },
              {
                displayName: 'Diagnóstico CIE-10',
                name: 'diagnosticosRI',
                renderProps: {
                  type: 'chips'
                },
                col: 12
              },
              {
                displayName: 'Enf. que motiva el soporte es oncologica',
                name: 'enfermedadOncologica',
                col: 12
              },
              {
                displayName: 'Antecedentes Clínicos Relevantes',
                name: 'antecedentesClinicos',
                col: 12
              },
              {
                displayName: 'Otros Antecedentes',
                name: 'otrosAntecedentes',
                col: 6
              },
              {
                displayName: 'Comentarios relevantes de antecedentes',
                name: 'comentarioRelevante',
                col: 6
              },
              {
                displayName: 'Alergias Relevantes',
                name: 'alergias',
                col: 12
              },
              {
                displayName: 'Otras alergias',
                name: 'otrasAlergias',
                col: 12
              },
              {
                displayName: 'Medicación habitual',
                name: 'medicacionHabitual',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condición Clínica',
            elements: [
              {
                displayName: 'Estable hemodinámicamente',
                name: 'estableHemodinamicamente',
                col: 3
              },
              {
                displayName: 'Estable de su enfermedad de base',
                name: 'estableEnfermedad',
                col: 3
              },
              {
                displayName: 'Nivel de conciencia normal',
                name: 'nivelConciencia',
                col: 3
              },
              {
                displayName: 'Escaras',
                name: 'escaras',
                col: 3
              },
              {
                displayName: 'Ostomías',
                name: 'ostomias',
                col: 3
              },
              {
                displayName: 'Otros relevantes',
                name: 'otrosRelevantes',
                col: 3
              }]

          }]

      }, {
        subSections: [
          {
            title: 'Datos clínicos',
            elements: [

              {
                displayName: 'Peso actual(Kg)',
                name: 'pesoActual',
                col: 3
              },
              {
                displayName: 'Talla (m)',
                name: 'talla',
                col: 3
              },
              {
                displayName: 'Nivel de actividad',
                name: 'idComboRIValorNivelActividad',
                col: 3
              },

              {
                displayName: 'Período de perdida de peso',
                name: 'idComboRIValorAduPerdidaPeso',
                col: 3
              },
              {
                displayName: 'Peso habitual (kg)',
                name: 'aduPesoHabitual',
                col: 3
              },
              {
                displayName: 'Evaluado',
                name: 'idComboRIValorAduEvaluado',
                col: 3
              },
              {
                displayName: 'IMC',
                name: 'aduIMC',
                col: 3
              },
              {
                displayName: '% Pérdida de peso',
                name: 'aduPerdidaPeso',
                col: 3
              },
              {
                displayName: 'Grado de desnutrición',
                name: 'idComboRIValorAduGradoDesnutricion',
                col: 3
              },
              {
                displayName: 'Diagnóstico nutricional',
                name: 'idComboRIValorAduDiagnosticoNutricional',
                col: 3
              },
              {
                displayName: 'Meta del soporte nutricional',
                name: 'idComboRIValorAduMetaNutricional',
                col: 3
              },
              {
                displayName: 'Circunferencia media braquial (Cm)',
                name: 'pedCircunferenciaMBraquial',
                col: 3
              },
              {
                displayName: 'Z Score Talla',
                name: 'pedZScoreTalla',
                col: 3
              },
              {
                displayName: 'Z Score Peso',
                name: 'pedZScorePeso',
                col: 3
              },
              {
                displayName: 'Z Score IMC',
                name: 'pedZScoreIMC',
                col: 3
              },
              {
                displayName: 'Diagnóstico nutricional por ind. Antropométricos',
                name: 'idComboRIValorPedDiagnosticoNutricional',
                col: 3
              },
              {
                displayName: 'Meta del soporte nutricional',
                name: 'idComboRIValorPedMetaSoporteNutricional',
                col: 3
              },
              {
                displayName: 'Requerimientos extra nutricionales',
                name: 'requerimientosExtraNutricionalesRI',
                col: 12
              },
              {
                displayName: 'Justificación Soporte',
                name: 'justificacionSoporteRI',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Programa AE',
    key: 'AE',
    sections: [
      {
        subSections: [
          {
            title: '',
            elements: [
              {
                displayName: 'Karnofsky',
                name: 'comboRIValorKarnofskyAE',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Requerimientos',
            elements: [
              {
                displayName: 'Proteínas Totales/d',
                name: 'proteinasTotalesAE',
                col: 3
              },
              {
                displayName: 'Calorías Totales/d',
                name: 'caloriasTotalesAE',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Accesos enterales',
            elements: [
              {
                displayName: 'Tipo de Acceso',
                name: 'comboRIValorTipoAccesoAE',
                col: 3
              },
              {
                displayName: 'Cambio de SNG en Domicilio?',
                name: 'cambioSNGdomicilio',
                col: 3
              },
              {
                displayName: 'Si es No Justificar',
                name: 'justificacionNoCambioSNG',
                col: 3
              },
              {
                displayName: 'Acceso enteral en buen estado?',
                name: 'accesoBuenEstado',
                col: 3
              },
              {
                displayName: 'Si es No Justificar',
                name: 'justificarMalEstado',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              {
                displayName: '',
                name: 'indicacionesAE',
                col: 12
              },
              {
                displayName: 'Modo de infusión',
                name: 'comboRIValorModoInfusionAE',
                col: 6
              },
              {
                displayName: 'Lleva bomba',
                name: 'llevaBomba',
                col: 6
              }]

          }]

      }]

  },
  {
    displayName: 'Programa AO',
    key: 'AO',
    sections: [
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              {
                displayName: '',
                name: 'indicacionesAO',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Programa AP',
    key: 'AP',
    sections: [
      {
        subSections: [
          {
            title: 'Paciente Adulto',
            elements: [
              { displayName: 'Karnofsky', name: 'comboRIValorKarnofsky', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Requerimientos',
            elements: [
              { displayName: 'Calorías /kg/d', name: 'calorias', col: 3 },
              { displayName: 'Hidratos de Carbono /kg/d', name: 'hidratosCarbono', col: 3 },
              { displayName: 'Proteínas /kg/d', name: 'proteinas', col: 3 },
              { displayName: 'Lípidos /kg/d', name: 'lipidos', col: 3 },
              { displayName: 'Proteínas totales /d', name: 'proteinasTotalesAP', col: 3 },
              { displayName: 'Lípidos totales /d', name: 'lipidosTotalesAP', col: 3 },
              { displayName: 'Calorías totales /d', name: 'caloriasTotalesAP', col: 3 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Paciente Pediatrico',
            elements: [
              { displayName: 'GER Formula de Schofield', name: 'formulaSchofieldPed', col: 3 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Último laboratorio',
            elements: [
              { displayName: 'Laboratorio', name: 'laboratorioAP', col: 12 },
              { displayName: '', name: 'laboratorioAdjunto', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Accesos Parenteral',
            elements: [
              { displayName: 'Tipo de Catéter', name: 'comboRIValorTipoCateter', col: 3 },
              { displayName: 'Justificar si es Transitorio', name: 'justificarTipoCateter', col: 3 },
              { displayName: 'Fecha de colocación', name: 'fechaColocacionCateter', col: 3 },
              { displayName: 'Ubicación de catéter', name: 'comboRIValorUbicacionCateter', col: 3 },
              { displayName: 'N° de lúmenes', name: 'comboRIValorNroLumenes', col: 3 },
              { displayName: '¿Sitio de inserción del catéter normal?', name: 'insercionCateterNormal', col: 3 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              { displayName: 'BAP Magistral', name: 'magistral', col: 3 },
              { displayName: 'Volumen', name: 'volumenMagistral', col: 3 },
              { displayName: 'Conexiones por semana', name: 'diasConexionSemanaMagistralAP', col: 12 },
              { displayName: 'BAP Estándar', name: 'bAPestandar', col: 3 },
              { displayName: '¿Cuál?', name: 'nombreInsumoAP', col: 3 },
              { displayName: 'Cantidad diaria', name: 'cantidadDiariaAP', col: 3 },
              { displayName: 'Motivo de la indicación Estándar', name: 'comboRIValorMotivoIndicacionEstandar', col: 3 },
              { displayName: 'Conexiones por semana', name: 'diasConexionSemanaAP', col: 12 },
              { displayName: '¿Requiere BAP magistral adelantada?', name: 'bAPxAdelantado', col: 6 },
              { displayName: 'Modo de infusión', name: 'comboRIValorModoInfusion', col: 3 },
              { displayName: 'Sellado de catéter', name: 'comboRIValorSelladoCateter', col: 3 }]

          }]

      }]

  },
  {
    displayName: 'Programa NPID',
    key: 'NPID',
    sections: [
      {
        subSections: [
          {
            title: 'Paciente Adulto',
            elements: [
              {
                displayName: 'Karnofsky',
                name: 'comboRIValorKarnofskyNPID',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Requerimientos',
            elements: [
              {
                displayName: 'Proteínas totales /d',
                name: 'proteinasTotalesNPID',
                col: 3
              },
              {
                displayName: 'Lípidos totales /d',
                name: 'lipidosTotalesNPID',
                col: 3
              },
              {
                displayName: 'Calorías totales /d',
                name: 'caloriasTotalesNPID',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Examen Físico',
            elements: [
              {
                displayName: 'Presencia de edemas',
                name: 'presenciaEdemas',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Último laboratorio',
            elements: [
              {
                displayName: 'Laboratorio',
                name: 'laboratorioNPID',
                col: 6
              },
              {
                displayName: '',
                name: 'laboratorioAdjuntoNPID',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Accesos NPID',
            elements: [
              {
                displayName: 'FAV',
                name: 'comboRIValorFAV',
                col: 3
              },
              {
                displayName: 'Catéter',
                name: 'comboRIValorTipoCateter',
                col: 3
              },
              {
                displayName: 'Fecha de colocación',
                name: 'fechaColocacionNPID',
                col: 3
              },
              {
                displayName: 'Ubicación de catéter',
                name: 'comboRIValorUbicacionNPID',
                col: 3
              },
              {
                displayName: 'N° de lúmenes',
                name: 'comboRIValorNroLumenesNPID',
                col: 3
              },
              {
                displayName: '¿Sitio de inserción del catéter normal?',
                name: 'cateterNormalNPID',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              {
                displayName: 'BAP Estándar',
                name: 'bAPestandarNPID',
                col: 3
              },
              {
                displayName: '¿Cuál?',
                name: 'nombreInsumoNPID',
                col: 3
              },
              {
                displayName: 'Cantidad diaria',
                name: 'cantidadDiariaNPID',
                col: 3
              },
              {
                displayName: 'Conexiones por semana',
                name: 'diasConexionSemanaNPID',
                col: 12
              },
              {
                displayName: 'BAP Magistral',
                name: 'magistralNPID',
                col: 3
              },
              {
                displayName: 'Volumen',
                name: 'volumenMagistralNPID',
                col: 3
              },
              {
                displayName: 'Motivo de la indicación Magistral',
                name: 'comboRIValorMotivoIndicacionMagistralNPID',
                col: 3
              },
              {
                displayName: 'Conexiones por semana',
                name: 'diasConexionSemanaMagistralNPID',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Programa DI',
    key: 'DI',
    sections: [
      {
        subSections: [
          {
            title: 'DI - Alimentación',
            elements: [
              { displayName: 'Videodeglución', name: 'videodeglucion', col: 3 },
              { displayName: 'Subir Informe de Videodeglución', name: 'videodeglucionAdjunto', col: 12 },
              { displayName: 'Disfagia a', name: 'dIDisfagiaARI', col: 12 },
              { displayName: 'Episodios anteriores de neumonía', name: 'episodiosNeumonia', col: 3 },
              { displayName: 'Alimentación actual', name: 'dIAlimentacionActualRI', col: 12 },
              { displayName: 'Hidratación actual', name: 'dIHidratacionActualRI', col: 12 },
              { displayName: 'Traqueostomía', name: 'traqueostomia', col: 3 },
              { displayName: 'Lúcido', name: 'lucido', col: 3 },
              { displayName: 'Compromiso motor', name: 'compromisoMotor', col: 3 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicación',
            elements: [
              { displayName: 'Nada por boca', name: 'nadaPorBoca', col: 3 },
              { displayName: 'Justificación Nada por boca', name: 'justificacionNadaPorBoca', col: 3 },
              { displayName: 'Hidratación', name: 'comboRIValorHidratacion', col: 3 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              { displayName: '', name: 'indicacionesDI', col: 12 }]

          }]

      }]

  },
  {
    displayName: 'Programa Cuidados Paliativos',
    key: 'CP',
    sections: [
      {
        subSections: [
          {
            title: 'Vida personal',
            elements: [
              {
                displayName: '¿Posee directivas anticipadas?',
                name: 'directivasAnticipadas',
                col: 3
              },
              {
                displayName: 'Subir directivas',
                name: 'directivasAdjunto',
                col: 12
              },
              {
                displayName: 'Creencia o religión',
                name: 'religion',
                col: 6
              },
              {
                displayName: 'Pasatiempos',
                name: 'pasatiempo',
                col: 6
              },
              {
                displayName: 'Profesión/ocupación',
                name: 'profesionOcupacion',
                col: 6
              },
              {
                displayName: 'Cuidador Principal?',
                name: 'cuidadorPrincipal',
                col: 6
              },
              {
                displayName: 'Medico de Cabecera',
                name: 'medicoCabecera',
                col: 6
              },
              {
                displayName: 'ECOG',
                name: 'comboRIValorECOG',
                col: 12
              },
              {
                displayName: 'Otros estudios',
                name: 'otrosEstudios',
                col: 6
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Estudios complementarios',
            elements: [
              {
                displayName: 'Estudio complementario',
                name: 'estudioAdjunto',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Hábitos',
            elements: [
              {
                displayName: 'Tabaquismo',
                name: 'comboRIValorTabaquismo',
                col: 3
              },
              {
                displayName: 'Antecedentes de alcoholismo',
                name: 'antecedenteAlcoholismo',
                col: 3
              },
              {
                displayName: 'Antecedentes de consumo de sustancias',
                name: 'antecedenteConsumoSustancias',
                col: 3
              },
              {
                displayName: 'Tipo de sustancia',
                name: 'descSustancia',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Examen Físico',
            elements: [
              {
                displayName: 'Tensión Arterial',
                name: 'tensionArterial',
                col: 3
              },
              {
                displayName: 'Frec. Cardiaca (L/min)',
                name: 'frecCardiaca',
                col: 3
              },
              {
                displayName: 'Frec. Respiratoria (R/min)',
                name: 'frecRespiratoria',
                col: 3
              },
              {
                displayName: 'Temperatura',
                name: 'temperatura',
                col: 3
              },
              {
                displayName: 'Piel/mucosas/faneras',
                name: 'pielMucosasFaneras',
                col: 3
              },
              {
                displayName: 'SNC',
                name: 'sNC',
                col: 3
              },
              {
                displayName: 'CV',
                name: 'cV',
                col: 3
              },
              {
                displayName: 'Respiratorio',
                name: 'respiratorio',
                col: 3
              },
              {
                displayName: 'Digestivo',
                name: 'digestivo',
                col: 3
              },
              {
                displayName: 'Videodeglución',
                name: 'videodeglucionCP',
                col: 3
              },
              {
                displayName: 'Subir Informe de Videodeglución',
                name: 'videodeglucionAdjuntoCP',
                col: 12
              },
              {
                displayName: 'Otros',
                name: 'otros',
                col: 3
              },
              {
                displayName: 'Sonda vesical',
                name: 'sondaVesicalCP',
                col: 3
              },
              {
                displayName: 'Catéter',
                name: 'cateterCP',
                col: 3
              },
              {
                displayName: 'Sonda nasogástrica',
                name: 'sondaNasogastricaCP',
                col: 3
              },
              {
                displayName: 'Requiere Soporte Nutricional',
                name: 'soporteNutricionalCP',
                col: 3
              },
              {
                displayName: 'ESAS',
                name: 'aduESAS',
                col: 3
              },
              {
                displayName: 'Resultado ESAS',
                name: 'resultadoAduESAS',
                col: 3
              },
              {
                displayName: 'Detalle Resultado ESAS',
                name: 'resultadoAduESASResumido',
                col: 12
              },
              {
                displayName: 'Escala LANSKY',
                name: 'idComboRIValorPedLANSKYCP',
                col: 12
              },
              {
                displayName: 'ESCALA GMFS',
                name: 'pedGMFS',
                col: 6
              },
              {
                displayName: 'Resultado GMFS',
                name: 'resultadoPedGMFS',
                col: 6
              },
              {
                displayName: 'Escala de Dolor',
                name: 'idComboRIValorPedEscalaDolorCP',
                col: 3
              },
              {
                displayName: 'Escala FLACC-R',
                name: 'pedFLACCR',
                col: 3
              },
              {
                displayName: 'Resultado FLACC-R',
                name: 'resultadoPedFLACCR',
                col: 3
              },
              {
                displayName: 'Escala de Gustave-Roussy',
                name: 'pedGustaveRoussy',
                col: 3
              },
              {
                displayName: 'Resultado Gustave-Roussy',
                name: 'resultadoPedGustaveRoussy',
                col: 3
              },
              {
                displayName: 'Escala FPS-R',
                name: 'pedFPSR',
                col: 3
              },
              {
                displayName: 'Resultado FPS-R',
                name: 'resultadoPedFPSR',
                col: 3
              },
              {
                displayName: 'Escala numérica de Dolor',
                name: 'escalaNumericaDolor',
                col: 3
              },
              {
                displayName: 'Resultado numérico de Dolor',
                name: 'resultadoEscalaNumericaDolor',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Situación socio-familiar',
            elements: [
              {
                displayName: '¿Vive solo?',
                name: 'viveSolo',
                col: 12
              },
              {
                displayName: '¿Tiene cuidadores contratados?',
                name: 'cuidadoresContratados',
                col: 12
              },
              {
                displayName: '¿Existe claudicación familiar?',
                name: 'claudicacionFamiliar',
                col: 12
              },
              {
                displayName: 'Otros datos socioeconómicos o familiares',
                name: 'datosSocioEcoFamiliares',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Situación de información del paciente y la familia',
            elements: [
              {
                displayName: '¿Posee información diagnóstica?',
                name: 'comboRIValorPoseeInfDiagnosticaCP',
                col: 12
              },
              {
                displayName: '¿Posee información sobre el pronóstico?',
                name: 'comboRIValorPoseeInfPronosticoCP',
                col: 12
              },
              {
                displayName: '¿Pide información sobre la enfermedad?',
                name: 'comboRIValorPoseeInfEnfermedadCP',
                col: 12
              },
              {
                displayName: '¿Nombra la palabra cáncer?',
                name: 'comboRIValorNombraPalabraCancerCP',
                col: 12
              },
              {
                displayName: '¿Hay cerco de silencio?',
                name: 'comboRIValorCercoDeSilencioCP',
                col: 12
              },
              {
                displayName: '¿Existe trastorno de adaptación?',
                name: 'comboRIValorTrastornoAdaptacionCP',
                col: 12
              },
              {
                displayName: 'Otros datos de información relevantes',
                name: 'otrosDatosInformacion',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Tratamiento actual',
            elements: [
              { displayName: '', name: 'cPMedicacionDosificacionRI', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Problemas principales a tratar',
            elements: [
              { displayName: 'Físicos', name: 'problemaFisico', col: 12 },
              { displayName: 'Psicológicos', name: 'problemaPsicologico', col: 12 },
              { displayName: 'Sociales', name: 'problemaSocial', col: 12 },
              { displayName: 'Espirituales', name: 'problemaEspiritual', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              { displayName: '', name: 'indicacionesCP', col: 12 },
              { displayName: 'Requerimientos', name: 'otrasIndicacionesCP', col: 12 }]

          }]

      }]

  },
  {
    displayName: 'Programa Cuidados Domiciliarios',
    key: 'Cuidados Domiciliario',
    sections: [
      {
        subSections: [
          {
            title: 'Examen Físico',
            elements: [
              {
                displayName: 'SNC',
                name: 'sNCCD',
                col: 12
              },
              {
                displayName: 'CV',
                name: 'cVCD',
                col: 12
              },
              {
                displayName: 'Respiratorio',
                name: 'respiratorioCD',
                col: 12
              },
              {
                displayName: 'Digestivo',
                name: 'digestivoCD',
                col: 12
              },
              {
                displayName: 'Videodeglución',
                name: 'videodeglucionCD',
                col: 12
              },
              {
                displayName: 'Subir Informe de Videodeglución',
                name: 'videodeglucionAdjuntoCD',
                col: 12
              },
              {
                displayName: 'Otros',
                name: 'otrosCD',
                col: 12
              },
              {
                displayName: 'Traqueostomía',
                name: 'traqueostomiaCD',
                col: 12
              },
              {
                displayName: 'Sonda vesical',
                name: 'sondaVesicalCD',
                col: 12
              },
              {
                displayName: 'Ostomía',
                name: 'ostomiaCD',
                col: 12
              },
              {
                displayName: 'Catéter',
                name: 'cateterCD',
                col: 12
              },
              {
                displayName: 'Sonda nasogástrica',
                name: 'sondaNasogastricaCD',
                col: 12
              },
              {
                displayName: 'Calendario vacunas completo',
                name: 'idComboRIValorCalendarioVacunasCD',
                col: 12
              },
              {
                displayName: 'Karnofsky',
                name: 'idComboRIValorAduKarnofskyCD',
                col: 12
              },
              {
                displayName: 'Escala LANSKY',
                name: 'idComboRIValorPedLANSKYCD',
                col: 12
              },
              {
                displayName: 'Requiere Soporte Nutricional',
                name: 'requiereSoporteNutricionalCD',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Hábitos',
            elements: [
              {
                displayName: 'Tabaquismo',
                name: 'idComboRIValorTabaquismoCD',
                col: 12
              },
              {
                displayName: 'Antecedentes de alcoholismo',
                name: 'antecedentesAlcoholismo',
                col: 12
              },
              {
                displayName: 'Antecedentes de consumo de sustancias',
                name: 'antecedenteConsumoSustanciaCD',
                col: 12
              },
              {
                displayName: 'Tipo de sustancia',
                name: 'tipoSustancia',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Infusión de Drogas',
            elements: [
              {
                displayName: 'Infusión de Drogas',
                name: 'infusionDrogas',
                col: 3
              },
              {
                displayName: 'Droga a Infundir?',
                name: 'drogasAInfundir',
                col: 12
              },
              {
                displayName: 'Dosis',
                name: 'dosis',
                col: 12
              },
              {
                displayName: 'Frecuencia',
                name: 'frecuencia',
                col: 12
              },
              {
                displayName: 'Cumple criterios de ingreso?',
                name: 'cumpleCriterioIngreso',
                col: 12
              },
              {
                displayName: 'Realizó infusiones previas',
                name: 'infusionesPrevias',
                col: 12
              },
              {
                displayName: 'Cuántas',
                name: 'cuantas',
                col: 12
              },
              {
                displayName: 'Dónde',
                name: 'donde',
                col: 12
              },
              {
                displayName: 'Presentó reacciones adversas',
                name: 'reaccionesAdversas',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Programa Keto',
    key: 'Keto',
    sections: [
      {
        subSections: [
          {
            title: 'Criterios de inclusión',
            elements: [
              {
                displayName: 'ERC estadio',
                name: 'idComboRIValorERCestadio',
                col: 12
              },
              {
                displayName: 'Paciente en hemodiálisis incremental',
                name: 'hemodialisisIncremental',
                col: 6
              },
              {
                displayName: 'Paciente no quiere dializar',
                name: 'quiereDialisis',
                col: 6
              },
              {
                displayName: 'Paciente post tx renal con deterioro',
                name: 'txrenalConDeterioro',
                col: 6
              },
              {
                displayName: 'Paciente en recuperación renal que sale de diálisis',
                name: 'recuperacionRenalDialisis',
                col: 6
              },
              {
                displayName: 'FG (MDRD/CKD-EPI)',
                name: 'fG',
                col: 12
              },
              {
                displayName: 'Laboratorio',
                name: 'laboratorioKETO',
                col: 12
              },
              {
                displayName: '',
                name: 'laboratorioAdjuntoKETO',
                col: 6
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              { displayName: '', name: 'indicacionesKeto', col: 12 }]

          }]

      }]

  },
  {
    displayName: 'Recomendación de Profesionales',
    key: 'Reco. Prof',
    sections: [
      {
        subSections: [
          {
            title: 'Equipo de seguimiento',
            elements: [
              {
                displayName: '',
                name: 'profesionalRI',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Equipo de especialistas',
            elements: [
              { displayName: '', name: 'profesionalEspecialidadRI', col: 12 }]

          }]

      }]

  },
  {
    displayName: 'Requerimientos adicionales',
    key: 'Adicional',
    sections: [
      {
        subSections: [
          {
            title: 'Requerimientos adicionales',
            elements: [
              {
                displayName: '',
                name: 'requerimientosAdicionales',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Condiciones Generales',
    key: 'Condiciones Generales',
    sections: [
      {
        subSections: [
          {
            title: 'Condiciones del paciente para el inicio',
            elements: [
              {
                displayName: 'Buena tolerancia al volumen y ritmo de infusión',
                name: 'buenaTolerancia',
                col: 12
              },
              {
                displayName: 'Debe continuar con otros tratamientos?',
                name: 'continuarOtroTratamiento',
                col: 12
              },
              {
                displayName: 'Indicar cual?',
                name: 'descOtroTratamiento',
                col: 12
              },
              {
                displayName: 'Al momento de confeccionar este documento el paciente se encuentra en condiciones de iniciar el SND?',
                name: 'inicioDeServicio',
                col: 12
              },
              {
                displayName: 'Justificar el NO',
                name: 'justificacionNoInicio',
                col: 12
              },
              {
                displayName: 'El paciente posee dispositivos para telemedicina?',
                name: 'dispositivoParaVideoConf',
                col: 12
              },
              {
                displayName: 'Fase del paciente al inicio',
                name: 'idComboRIValorFasePaciente',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones del domicilio según referencia paciente/cuidador',
            elements: [
              {
                displayName: 'Domicilio accesible?',
                name: 'domicilioAccesible',
                col: 12
              },
              {
                displayName: 'Agua potable?',
                name: 'aguaPotable',
                col: 12
              },
              {
                displayName: 'Red eléctrica?',
                name: 'redElectrica',
                col: 12
              },
              {
                displayName: 'Paciente/familiar comprende y acepta el servicio?',
                name: 'comprendeAceptaServicio',
                col: 12
              },
              {
                displayName: 'Higiene del domicilio aceptable?',
                name: 'higiene',
                col: 12
              },
              {
                displayName: 'Lugar seguro para el almacenamiento?',
                name: 'almacenamiento',
                col: 12
              },
              {
                displayName: 'Cuidadores en domicilio?',
                name: 'cuidador',
                col: 12
              },
              {
                displayName: 'Tiene internación domiciliaria?',
                name: 'internacionDomiciliaria',
                col: 12
              },
              {
                displayName: 'Prestación que recibe?',
                name: 'prestacion',
                col: 6
              },
              {
                displayName: 'Empresa que se lo realiza?',
                name: 'empresa',
                col: 6
              },
              {
                displayName: 'Observaciones',
                name: 'observaciones',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones de la institución donde se presta el servicio',
            elements: [
              {
                displayName: 'Cumple condiciones de higiene?',
                name: 'higieneInstitucion',
                col: 12
              },
              {
                displayName: 'Espacio para almacenar insumos?',
                name: 'almacenamientoInstitucion',
                col: 12
              },
              {
                displayName: 'Servicio a cargo del personal de la institución?',
                name: 'personalInstitucion',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones para brindar servicio',
            elements: [
              {
                displayName: 'Evaluación del grupo familiar y entorno psicosocial del paciente es adecuada?',
                name: 'evaluacionFamiliaPsicosocial',
                col: 12
              },
              {
                displayName: 'Conclusión',
                name: 'conclusion',
                col: 12
              },

              {
                displayName: 'Consentimiento Informado',
                name: 'consentimientoInformado',
                disableFuture: true,
                col: 12
              },
              {
                displayName: 'Fecha de firma',
                name: 'fechaFirmaConsentimiento',
                col: 12
              },
              {
                displayName: '',
                name: 'consentimientoInput',
                col: 12
              }]

          }]

      }]

  }];


const modulosSoloCP = [
  {
    displayName: 'Datos Generales',
    key: 'Datos Generales',
    sections: [
      {
        subSections: [
          {
            title: 'Programa tipo',
            elements: [
              {
                displayName: '',
                name: 'selectedPrograms',
                col: 12
              }]

          },
          {
            title: 'Datos filiatorios',
            elements: [
              {
                displayName: 'N° HC',
                name: 'hC',
                col: 3
              },
              {
                displayName: 'Nombre',
                name: 'nombre',
                col: 3
              },
              {
                displayName: 'Apellido',
                name: 'apellido',
                col: 3
              },
              {
                displayName: 'DNI N°',
                name: 'dNI',
                col: 3
              },
              {
                displayName: 'Fecha nacimiento',
                name: 'fechaNacimiento',
                col: 3
              },
              {
                displayName: 'Edad',
                name: 'edadAnios',
                col: 3
              },
              {
                displayName: 'Sexo',
                name: 'sexo',
                col: 3
              },
              {
                displayName: 'Domicilio',
                name: 'domicilio',
                col: 3
              },
              {
                displayName: 'Financiador',
                name: 'financiador',
                col: 3
              },
              {
                displayName: 'N° afiliado',
                name: 'nroAfiliado',
                col: 3
              },
              {
                displayName: 'Tel. de contacto',
                name: 'telContacto',
                col: 3
              },
              {
                displayName: 'Familiar de contacto',
                name: 'familiarContacto',
                col: 3
              },
              {
                displayName: 'Tel Familiar',
                name: 'telFamiliar',
                col: 3
              },
              {
                displayName: 'Médico de contacto',
                name: 'medicoPrescriptor',
                col: 3
              },
              {
                displayName: 'Lugar donde se prestara el servicio',
                name: 'comboRIValorLugarServicio',
                col: 6
              },
              {
                displayName: 'Centro de referencia',
                name: 'centroReferencia',
                col: 3
              },
              {
                displayName: 'Centro de referencia',
                name: 'codInstitucionReferencia',
                col: 3
              },
              {
                displayName: 'Lugar de RI',
                name: 'comboRIValorLugarRI',
                col: 6
              },
              {
                displayName: '¿Que servicio de emergencia posee?',
                name: 'servicioEmergencia',
                col: 3
              },
              {
                displayName: 'Telefono de Emergencia',
                name: 'telefonoEmergencia',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Resumen de HCL',
            elements: [
              {
                displayName: 'Resumen de HCL',
                name: 'resumenHCL',
                col: 12
              },
              {
                displayName: 'Diagnóstico al alta',
                name: 'diagnosticoAlta',
                col: 12
              },
              {
                displayName: 'Diagnóstico CIE-10',
                name: 'diagnosticosRI',
                renderProps: {
                  type: 'chips'
                },
                col: 12
              },
              {
                displayName: 'Enf. que motiva el soporte es oncologica',
                name: 'enfermedadOncologica',
                col: 12
              },
              {
                displayName: 'Antecedentes Clínicos Relevantes',
                name: 'antecedentesClinicos',
                col: 12
              },
              {
                displayName: 'Otros Antecedentes',
                name: 'otrosAntecedentes',
                col: 6
              },
              {
                displayName: 'Comentarios relevantes de antecedentes',
                name: 'comentarioRelevante',
                col: 6
              },
              {
                displayName: 'Alergias Relevantes',
                name: 'alergias',
                col: 12
              },
              {
                displayName: 'Otras alergias',
                name: 'otrasAlergias',
                col: 12
              },
              {
                displayName: 'Medicación habitual',
                name: 'medicacionHabitual',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condición Clínica',
            elements: [
              {
                displayName: 'Estable hemodinámicamente',
                name: 'estableHemodinamicamente',
                col: 3
              },
              {
                displayName: 'Estable de su enfermedad de base',
                name: 'estableEnfermedad',
                col: 3
              },
              {
                displayName: 'Nivel de conciencia normal',
                name: 'nivelConciencia',
                col: 3
              },
              {
                displayName: 'Escaras',
                name: 'escaras',
                col: 3
              },
              {
                displayName: 'Ostomías',
                name: 'ostomias',
                col: 3
              },
              {
                displayName: 'Otros relevantes',
                name: 'otrosRelevantes',
                col: 3
              }]

          }]

      }, {
        subSections: [
          {
            title: 'Datos clínicos',
            elements: [

              {
                displayName: 'Peso actual(Kg)',
                name: 'pesoActual',
                col: 3
              },
              {
                displayName: 'Talla (m)',
                name: 'talla',
                col: 3
              },
              {
                displayName: 'Nivel de actividad',
                name: 'idComboRIValorNivelActividad',
                col: 3
              },

              {
                displayName: 'Período de perdida de peso',
                name: 'idComboRIValorAduPerdidaPeso',
                col: 3
              },
              {
                displayName: 'Peso habitual (kg)',
                name: 'aduPesoHabitual',
                col: 3
              },
              {
                displayName: 'Evaluado',
                name: 'idComboRIValorAduEvaluado',
                col: 3
              },
              {
                displayName: 'IMC',
                name: 'aduIMC',
                col: 3
              },
              {
                displayName: '% Pérdida de peso',
                name: 'aduPerdidaPeso',
                col: 3
              },
              {
                displayName: 'Grado de desnutrición',
                name: 'idComboRIValorAduGradoDesnutricion',
                col: 3
              },
              {
                displayName: 'Diagnóstico nutricional',
                name: 'idComboRIValorAduDiagnosticoNutricional',
                col: 3
              },
              {
                displayName: 'Meta del soporte nutricional',
                name: 'idComboRIValorAduMetaNutricional',
                col: 3
              },
              {
                displayName: 'Circunferencia media braquial (Cm)',
                name: 'pedCircunferenciaMBraquial',
                col: 3
              },
              {
                displayName: 'Z Score Talla',
                name: 'pedZScoreTalla',
                col: 3
              },
              {
                displayName: 'Z Score Peso',
                name: 'pedZScorePeso',
                col: 3
              },
              {
                displayName: 'Z Score IMC',
                name: 'pedZScoreIMC',
                col: 3
              },
              {
                displayName: 'Diagnóstico nutricional por ind. Antropométricos',
                name: 'idComboRIValorPedDiagnosticoNutricional',
                col: 3
              },
              {
                displayName: 'Meta del soporte nutricional',
                name: 'idComboRIValorPedMetaSoporteNutricional',
                col: 3
              },
              {
                displayName: 'Requerimientos extra nutricionales',
                name: 'requerimientosExtraNutricionalesRI',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Programa Cuidados Paliativos',
    key: 'CP',
    sections: [
      {
        subSections: [
          {
            title: 'Vida personal',
            elements: [
              {
                displayName: '¿Posee directivas anticipadas?',
                name: 'directivasAnticipadas',
                col: 3
              },
              {
                displayName: 'Subir directivas',
                name: 'directivasAdjunto',
                col: 12
              },
              {
                displayName: 'Creencia o religión',
                name: 'religion',
                col: 6
              },
              {
                displayName: 'Pasatiempos',
                name: 'pasatiempo',
                col: 6
              },
              {
                displayName: 'Profesión/ocupación',
                name: 'profesionOcupacion',
                col: 6
              },
              {
                displayName: 'Cuidador Principal?',
                name: 'cuidadorPrincipal',
                col: 6
              },
              {
                displayName: 'Medico de Cabecera',
                name: 'medicoCabecera',
                col: 6
              },
              {
                displayName: 'ECOG',
                name: 'comboRIValorECOG',
                col: 12
              },
              {
                displayName: 'Otros estudios',
                name: 'otrosEstudios',
                col: 6
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Estudios complementarios',
            elements: [
              {
                displayName: 'Estudio complementario',
                name: 'estudioAdjunto',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Hábitos',
            elements: [
              {
                displayName: 'Tabaquismo',
                name: 'comboRIValorTabaquismo',
                col: 3
              },
              {
                displayName: 'Antecedentes de alcoholismo',
                name: 'antecedenteAlcoholismo',
                col: 3
              },
              {
                displayName: 'Antecedentes de consumo de sustancias',
                name: 'antecedenteConsumoSustancias',
                col: 3
              },
              {
                displayName: 'Tipo de sustancia',
                name: 'descSustancia',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Examen Físico',
            elements: [
              {
                displayName: 'Tensión Arterial',
                name: 'tensionArterial',
                col: 3
              },
              {
                displayName: 'Frec. Cardiaca (L/min)',
                name: 'frecCardiaca',
                col: 3
              },
              {
                displayName: 'Frec. Respiratoria (R/min)',
                name: 'frecRespiratoria',
                col: 3
              },
              {
                displayName: 'Temperatura',
                name: 'temperatura',
                col: 3
              },
              {
                displayName: 'Piel/mucosas/faneras',
                name: 'pielMucosasFaneras',
                col: 3
              },
              {
                displayName: 'SNC',
                name: 'sNC',
                col: 3
              },
              {
                displayName: 'CV',
                name: 'cV',
                col: 3
              },
              {
                displayName: 'Respiratorio',
                name: 'respiratorio',
                col: 3
              },
              {
                displayName: 'Digestivo',
                name: 'digestivo',
                col: 3
              },
              {
                displayName: 'Videodeglución',
                name: 'videodeglucionCP',
                col: 3
              },
              {
                displayName: 'Subir Informe de Videodeglución',
                name: 'videodeglucionAdjuntoCP',
                col: 12
              },
              {
                displayName: 'Otros',
                name: 'otros',
                col: 3
              },
              {
                displayName: 'Sonda vesical',
                name: 'sondaVesicalCP',
                col: 3
              },
              {
                displayName: 'Catéter',
                name: 'cateterCP',
                col: 3
              },
              {
                displayName: 'Sonda nasogástrica',
                name: 'sondaNasogastricaCP',
                col: 3
              },
              {
                displayName: 'Requiere Soporte Nutricional',
                name: 'soporteNutricionalCP',
                col: 3
              },
              {
                displayName: 'ESAS',
                name: 'aduESAS',
                col: 3
              },
              {
                displayName: 'Resultado ESAS',
                name: 'resultadoAduESAS',
                col: 3
              },
              {
                displayName: 'Detalle Resultado ESAS',
                name: 'resultadoAduESASResumido',
                col: 12
              },
              {
                displayName: 'Escala LANSKY',
                name: 'idComboRIValorPedLANSKYCP',
                col: 12
              },
              {
                displayName: 'ESCALA GMFS',
                name: 'pedGMFS',
                col: 6
              },
              {
                displayName: 'Resultado GMFS',
                name: 'resultadoPedGMFS',
                col: 6
              },
              {
                displayName: 'Escala de Dolor',
                name: 'idComboRIValorPedEscalaDolorCP',
                col: 3
              },
              {
                displayName: 'Escala FLACC-R',
                name: 'pedFLACCR',
                col: 3
              },
              {
                displayName: 'Resultado FLACC-R',
                name: 'resultadoPedFLACCR',
                col: 3
              },
              {
                displayName: 'Escala de Gustave-Roussy',
                name: 'pedGustaveRoussy',
                col: 3
              },
              {
                displayName: 'Resultado Gustave-Roussy',
                name: 'resultadoPedGustaveRoussy',
                col: 3
              },
              {
                displayName: 'Escala FPS-R',
                name: 'pedFPSR',
                col: 3
              },
              {
                displayName: 'Resultado FPS-R',
                name: 'resultadoPedFPSR',
                col: 3
              },
              {
                displayName: 'Escala numérica de Dolor',
                name: 'escalaNumericaDolor',
                col: 3
              },
              {
                displayName: 'Resultado numérico de Dolor',
                name: 'resultadoEscalaNumericaDolor',
                col: 3
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Situación socio-familiar',
            elements: [
              {
                displayName: '¿Vive solo?',
                name: 'viveSolo',
                col: 12
              },
              {
                displayName: '¿Tiene cuidadores contratados?',
                name: 'cuidadoresContratados',
                col: 12
              },
              {
                displayName: '¿Existe claudicación familiar?',
                name: 'claudicacionFamiliar',
                col: 12
              },
              {
                displayName: 'Otros datos socioeconómicos o familiares',
                name: 'datosSocioEcoFamiliares',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Situación de información del paciente y la familia',
            elements: [
              {
                displayName: '¿Posee información diagnóstica?',
                name: 'comboRIValorPoseeInfDiagnosticaCP',
                col: 12
              },
              {
                displayName: '¿Posee información sobre el pronóstico?',
                name: 'comboRIValorPoseeInfPronosticoCP',
                col: 12
              },
              {
                displayName: '¿Pide información sobre la enfermedad?',
                name: 'comboRIValorPoseeInfEnfermedadCP',
                col: 12
              },
              {
                displayName: '¿Nombra la palabra cáncer?',
                name: 'comboRIValorNombraPalabraCancerCP',
                col: 12
              },
              {
                displayName: '¿Hay cerco de silencio?',
                name: 'comboRIValorCercoDeSilencioCP',
                col: 12
              },
              {
                displayName: '¿Existe trastorno de adaptación?',
                name: 'comboRIValorTrastornoAdaptacionCP',
                col: 12
              },
              {
                displayName: 'Otros datos de información relevantes',
                name: 'otrosDatosInformacion',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Tratamiento actual',
            elements: [
              { displayName: '', name: 'cPMedicacionDosificacionRI', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Problemas principales a tratar',
            elements: [
              { displayName: 'Físicos', name: 'problemaFisico', col: 12 },
              { displayName: 'Psicológicos', name: 'problemaPsicologico', col: 12 },
              { displayName: 'Sociales', name: 'problemaSocial', col: 12 },
              { displayName: 'Espirituales', name: 'problemaEspiritual', col: 12 }]

          }]

      },
      {
        subSections: [
          {
            title: 'Indicaciones',
            elements: [
              { displayName: '', name: 'indicacionesCP', col: 12 },
              { displayName: 'Requerimientos', name: 'otrasIndicacionesCP', col: 12 }]

          }]

      }]

  },
  {
    displayName: 'Requerimientos adicionales',
    key: 'Adicional',
    sections: [
      {
        subSections: [
          {
            title: 'Requerimientos adicionales',
            elements: [
              {
                displayName: '',
                name: 'requerimientosAdicionales',
                col: 12
              }]

          }]

      }]

  },
  {
    displayName: 'Condiciones Generales',
    key: 'Condiciones Generales',
    sections: [
      {
        subSections: [
          {
            title: 'Condiciones del paciente para el inicio',
            elements: [
              {
                displayName: 'Buena tolerancia al volumen y ritmo de infusión',
                name: 'buenaTolerancia',
                col: 12
              },
              {
                displayName: 'Debe continuar con otros tratamientos?',
                name: 'continuarOtroTratamiento',
                col: 12
              },
              {
                displayName: 'Indicar cual?',
                name: 'descOtroTratamiento',
                col: 12
              },
              {
                displayName: 'Al momento de confeccionar este documento el paciente se encuentra en condiciones de iniciar el SND?',
                name: 'inicioDeServicio',
                col: 12
              },
              {
                displayName: 'Justificar el NO',
                name: 'justificacionNoInicio',
                col: 12
              },
              {
                displayName: 'El paciente posee dispositivos para telemedicina?',
                name: 'dispositivoParaVideoConf',
                col: 12
              },
              {
                displayName: 'Fase del paciente al inicio',
                name: 'idComboRIValorFasePaciente',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones del domicilio según referencia paciente/cuidador',
            elements: [
              {
                displayName: 'Domicilio accesible?',
                name: 'domicilioAccesible',
                col: 12
              },
              {
                displayName: 'Agua potable?',
                name: 'aguaPotable',
                col: 12
              },
              {
                displayName: 'Red eléctrica?',
                name: 'redElectrica',
                col: 12
              },
              {
                displayName: 'Paciente/familiar comprende y acepta el servicio?',
                name: 'comprendeAceptaServicio',
                col: 12
              },
              {
                displayName: 'Higiene del domicilio aceptable?',
                name: 'higiene',
                col: 12
              },
              {
                displayName: 'Cuidadores en domicilio?',
                name: 'cuidador',
                col: 12
              },
              {
                displayName: 'Tiene internación domiciliaria?',
                name: 'internacionDomiciliaria',
                col: 12
              },
              {
                displayName: 'Prestación que recibe?',
                name: 'prestacion',
                col: 6
              },
              {
                displayName: 'Empresa que se lo realiza?',
                name: 'empresa',
                col: 6
              },
              {
                displayName: 'Observaciones',
                name: 'observaciones',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones de la institución donde se presta el servicio',
            elements: [
              {
                displayName: 'Cumple condiciones de higiene?',
                name: 'higieneInstitucion',
                col: 12
              },
              {
                displayName: 'Espacio para almacenar insumos?',
                name: 'almacenamientoInstitucion',
                col: 12
              },
              {
                displayName: 'Servicio a cargo del personal de la institución?',
                name: 'personalInstitucion',
                col: 12
              }]

          }]

      },
      {
        subSections: [
          {
            title: 'Condiciones para brindar servicio',
            elements: [
              {
                displayName: 'Evaluación del grupo familiar y entorno psicosocial del paciente es adecuada?',
                name: 'evaluacionFamiliaPsicosocial',
                col: 12
              },
              {
                displayName: 'Conclusión',
                name: 'conclusion',
                col: 12
              },

              {
                displayName: 'Consentimiento Informado',
                name: 'consentimientoInformado',
                disableFuture: true,
                col: 12
              },
              {
                displayName: 'Fecha de firma',
                name: 'fechaFirmaConsentimiento',
                col: 12
              },
              {
                displayName: '',
                name: 'consentimientoInput',
                col: 12
              }]

          }]

      }]

  }];